var items = {
  "block.minecraft.acacia_button": "Kenop pilang",
  "block.minecraft.acacia_door": "Pintoe pilang",
  "block.minecraft.acacia_fence": "Pagar pilang",
  "block.minecraft.acacia_fence_gate": "Pintoe pagar pilang",
  "block.minecraft.acacia_hanging_sign": "Papan tanda gantoeng pilang",
  "block.minecraft.acacia_leaves": "Daoen pilang",
  "block.minecraft.acacia_log": "Gelondong pilang",
  "block.minecraft.acacia_planks": "Papan pilang",
  "block.minecraft.acacia_pressure_plate": "Pelat penekan pilang",
  "block.minecraft.acacia_sapling": "Bibit pilang",
  "block.minecraft.acacia_shelf": "Rak pilang",
  "block.minecraft.acacia_sign": "Papan tanda pilang",
  "block.minecraft.acacia_slab": "Pelat pilang",
  "block.minecraft.acacia_stairs": "Tangga pilang",
  "block.minecraft.acacia_trapdoor": "Pintoe kolong pilang",
  "block.minecraft.acacia_wall_hanging_sign": "Papan tanda gantoeng dinding pilang",
  "block.minecraft.acacia_wall_sign": "Papan tanda dinding pilang",
  "block.minecraft.acacia_wood": "Kajoe pilang",
  "block.minecraft.activator_rail": "Spoor pengaktif",
  "block.minecraft.air": "Oedara",
  "block.minecraft.allium": "Boenga bawang",
  "block.minecraft.amethyst_block": "Balok ketjoeboeng",
  "block.minecraft.amethyst_cluster": "Goegoes ketjoeboeng",
  "block.minecraft.ancient_debris": "Poeing poerba",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Pelat andesit",
  "block.minecraft.andesite_stairs": "Tangga andesit",
  "block.minecraft.andesite_wall": "Tembok andesit",
  "block.minecraft.anvil": "Paron",
  "block.minecraft.attached_melon_stem": "Batang semangka tertempel",
  "block.minecraft.attached_pumpkin_stem": "Batang laboe tertempel",
  "block.minecraft.azalea": "Kadoedampit",
  "block.minecraft.azalea_leaves": "Daoen kadoedampit",
  "block.minecraft.azure_bluet": "Boenga liar biroe",
  "block.minecraft.bamboo": "Bamboe",
  "block.minecraft.bamboo_block": "Balok bamboe",
  "block.minecraft.bamboo_button": "Kenop bamboe",
  "block.minecraft.bamboo_door": "Pintoe bamboe",
  "block.minecraft.bamboo_fence": "Pagar bamboe",
  "block.minecraft.bamboo_fence_gate": "Pintoe pagar bamboe",
  "block.minecraft.bamboo_hanging_sign": "Papan tanda gantoeng bamboe",
  "block.minecraft.bamboo_mosaic": "Anjaman bamboe",
  "block.minecraft.bamboo_mosaic_slab": "Pelat anjaman bamboe",
  "block.minecraft.bamboo_mosaic_stairs": "Tangga anjaman bamboe",
  "block.minecraft.bamboo_planks": "Papan bamboe",
  "block.minecraft.bamboo_pressure_plate": "Pelat penekan bamboe",
  "block.minecraft.bamboo_sapling": "Reboeng",
  "block.minecraft.bamboo_shelf": "Rak bamboe",
  "block.minecraft.bamboo_sign": "Papan tanda bamboe",
  "block.minecraft.bamboo_slab": "Pelat bamboe",
  "block.minecraft.bamboo_stairs": "Tangga bamboe",
  "block.minecraft.bamboo_trapdoor": "Pintoe kolong bamboe",
  "block.minecraft.bamboo_wall_hanging_sign": "Papan tanda gantoeng dinding bamboe",
  "block.minecraft.bamboo_wall_sign": "Papan tanda gantoeng bamboe",
  "block.minecraft.banner.base.black": "Moeka hitam",
  "block.minecraft.banner.base.blue": "Moeka biroe",
  "block.minecraft.banner.base.brown": "Moeka sawo matang",
  "block.minecraft.banner.base.cyan": "Moeka nilangsoeka",
  "block.minecraft.banner.base.gray": "Moeka kelaboe",
  "block.minecraft.banner.base.green": "Moeka hidjau",
  "block.minecraft.banner.base.light_blue": "Moeka biroe moeda",
  "block.minecraft.banner.base.light_gray": "Moeka kelaboe moeda",
  "block.minecraft.banner.base.lime": "Moeka hidjau poepoes",
  "block.minecraft.banner.base.magenta": "Moeka patma",
  "block.minecraft.banner.base.orange": "Moeka oranje",
  "block.minecraft.banner.base.pink": "Moeka djambon",
  "block.minecraft.banner.base.purple": "Moeka oengoe",
  "block.minecraft.banner.base.red": "Moeka merah",
  "block.minecraft.banner.base.white": "Moeka poetih",
  "block.minecraft.banner.base.yellow": "Moeka koening",
  "block.minecraft.banner.border.black": "Tepi hitam",
  "block.minecraft.banner.border.blue": "Tepi biroe",
  "block.minecraft.banner.border.brown": "Tepi sawo matang",
  "block.minecraft.banner.border.cyan": "Tepi nilangsoeka",
  "block.minecraft.banner.border.gray": "Tepi kelaboe",
  "block.minecraft.banner.border.green": "Tepi hidjau",
  "block.minecraft.banner.border.light_blue": "Tepi biroe moeda",
  "block.minecraft.banner.border.light_gray": "Tepi kelaboe moeda",
  "block.minecraft.banner.border.lime": "Tepi hidjau poepoes",
  "block.minecraft.banner.border.magenta": "Tepi patma",
  "block.minecraft.banner.border.orange": "Tepi oranje",
  "block.minecraft.banner.border.pink": "Tepi djambon",
  "block.minecraft.banner.border.purple": "Tepi oengoe",
  "block.minecraft.banner.border.red": "Tepi merah",
  "block.minecraft.banner.border.white": "Tepi poetih",
  "block.minecraft.banner.border.yellow": "Tepi koening",
  "block.minecraft.banner.bricks.black": "Bataän hitam",
  "block.minecraft.banner.bricks.blue": "Bataän biroe",
  "block.minecraft.banner.bricks.brown": "Bataän sawo matang",
  "block.minecraft.banner.bricks.cyan": "Bataän nilangsoeka",
  "block.minecraft.banner.bricks.gray": "Bataän kelaboe",
  "block.minecraft.banner.bricks.green": "Bataän hidjau",
  "block.minecraft.banner.bricks.light_blue": "Bataän biroe moeda",
  "block.minecraft.banner.bricks.light_gray": "Bataän kelaboe moeda",
  "block.minecraft.banner.bricks.lime": "Bataän hidjau poepoes",
  "block.minecraft.banner.bricks.magenta": "Bataän patma",
  "block.minecraft.banner.bricks.orange": "Bataän oranje",
  "block.minecraft.banner.bricks.pink": "Bataän djambon",
  "block.minecraft.banner.bricks.purple": "Bataän oengoe",
  "block.minecraft.banner.bricks.red": "Bataän merah",
  "block.minecraft.banner.bricks.white": "Bataän poetih",
  "block.minecraft.banner.bricks.yellow": "Bataän koening",
  "block.minecraft.banner.circle.black": "Boendar hitam",
  "block.minecraft.banner.circle.blue": "Boendar biroe",
  "block.minecraft.banner.circle.brown": "Boendar sawo matang",
  "block.minecraft.banner.circle.cyan": "Boendar nilangsoeka",
  "block.minecraft.banner.circle.gray": "Boendar kelaboe",
  "block.minecraft.banner.circle.green": "Boendar hidjau",
  "block.minecraft.banner.circle.light_blue": "Boendar biroe moeda",
  "block.minecraft.banner.circle.light_gray": "Boendar kelaboe moeda",
  "block.minecraft.banner.circle.lime": "Boendar hidjau poepoes",
  "block.minecraft.banner.circle.magenta": "Boendar patma",
  "block.minecraft.banner.circle.orange": "Boendar oranje",
  "block.minecraft.banner.circle.pink": "Boendar djambon",
  "block.minecraft.banner.circle.purple": "Boendar oengoe",
  "block.minecraft.banner.circle.red": "Boendar merah",
  "block.minecraft.banner.circle.white": "Boendar poetih",
  "block.minecraft.banner.circle.yellow": "Boendar koening",
  "block.minecraft.banner.creeper.black": "Roepa creeper hitam",
  "block.minecraft.banner.creeper.blue": "Roepa creeper biroe",
  "block.minecraft.banner.creeper.brown": "Roepa creeper sawo matang",
  "block.minecraft.banner.creeper.cyan": "Roepa creeper nilangsoeka",
  "block.minecraft.banner.creeper.gray": "Roepa creeper kelaboe",
  "block.minecraft.banner.creeper.green": "Roepa creeper hidjau",
  "block.minecraft.banner.creeper.light_blue": "Roepa creeper biroe moeda",
  "block.minecraft.banner.creeper.light_gray": "Roepa creeper kelaboe moeda",
  "block.minecraft.banner.creeper.lime": "Roepa creeper hidjau poepoes",
  "block.minecraft.banner.creeper.magenta": "Roepa creeper patma",
  "block.minecraft.banner.creeper.orange": "Roepa creeper oranje",
  "block.minecraft.banner.creeper.pink": "Roepa creeper djambon",
  "block.minecraft.banner.creeper.purple": "Roepa creeper oengoe",
  "block.minecraft.banner.creeper.red": "Roepa creeper merah",
  "block.minecraft.banner.creeper.white": "Roepa creeper poetih",
  "block.minecraft.banner.creeper.yellow": "Roepa creeper koening",
  "block.minecraft.banner.cross.black": "Silang hitam",
  "block.minecraft.banner.cross.blue": "Silang biroe",
  "block.minecraft.banner.cross.brown": "Silang sawo matang",
  "block.minecraft.banner.cross.cyan": "Silang nilangsoeka",
  "block.minecraft.banner.cross.gray": "Silang kelaboe",
  "block.minecraft.banner.cross.green": "Silang hidjau",
  "block.minecraft.banner.cross.light_blue": "Silang biroe moeda",
  "block.minecraft.banner.cross.light_gray": "Silang kelaboe moeda",
  "block.minecraft.banner.cross.lime": "Silang hidjau poepoes",
  "block.minecraft.banner.cross.magenta": "Silang patma",
  "block.minecraft.banner.cross.orange": "Silang oranje",
  "block.minecraft.banner.cross.pink": "Silang djambon",
  "block.minecraft.banner.cross.purple": "Silang oengoe",
  "block.minecraft.banner.cross.red": "Silang merah",
  "block.minecraft.banner.cross.white": "Silang poetih",
  "block.minecraft.banner.cross.yellow": "Silang koening",
  "block.minecraft.banner.curly_border.black": "Tepi bertakik hitam",
  "block.minecraft.banner.curly_border.blue": "Tepi bertakik biroe",
  "block.minecraft.banner.curly_border.brown": "Tepi bertakik sawo matang",
  "block.minecraft.banner.curly_border.cyan": "Tepi bertakik nilangsoeka",
  "block.minecraft.banner.curly_border.gray": "Tepi bertakik kelaboe",
  "block.minecraft.banner.curly_border.green": "Tepi bertakik hidjau",
  "block.minecraft.banner.curly_border.light_blue": "Tepi bertakik biroe moeda",
  "block.minecraft.banner.curly_border.light_gray": "Tepi bertakik kelaboe moeda",
  "block.minecraft.banner.curly_border.lime": "Tepi bertakik hidjau poepoes",
  "block.minecraft.banner.curly_border.magenta": "Tepi bertakik patma",
  "block.minecraft.banner.curly_border.orange": "Tepi bertakik oranje",
  "block.minecraft.banner.curly_border.pink": "Tepi bertakik djambon",
  "block.minecraft.banner.curly_border.purple": "Tepi bertakik oengoe",
  "block.minecraft.banner.curly_border.red": "Tepi bertakik merah",
  "block.minecraft.banner.curly_border.white": "Tepi bertakik poetih",
  "block.minecraft.banner.curly_border.yellow": "Tepi bertakik koening",
  "block.minecraft.banner.diagonal_left.black": "Paroeh serong kidal hitam",
  "block.minecraft.banner.diagonal_left.blue": "Paroeh serong kidal biroe",
  "block.minecraft.banner.diagonal_left.brown": "Paroeh serong kidal sawo matang",
  "block.minecraft.banner.diagonal_left.cyan": "Paroeh serong kidal nilangsoeka",
  "block.minecraft.banner.diagonal_left.gray": "Paroeh serong kidal kelaboe",
  "block.minecraft.banner.diagonal_left.green": "Paroeh serong kidal hidjau",
  "block.minecraft.banner.diagonal_left.light_blue": "Paroeh serong kidal biroe moeda",
  "block.minecraft.banner.diagonal_left.light_gray": "Paroeh serong kidal kelaboe moeda",
  "block.minecraft.banner.diagonal_left.lime": "Paroeh serong kidal hidjau poepoes",
  "block.minecraft.banner.diagonal_left.magenta": "Paroeh serong kidal patma",
  "block.minecraft.banner.diagonal_left.orange": "Paroeh serong kidal oranje",
  "block.minecraft.banner.diagonal_left.pink": "Paroeh serong kidal djambon",
  "block.minecraft.banner.diagonal_left.purple": "Paroeh serong kidal oengoe",
  "block.minecraft.banner.diagonal_left.red": "Paroeh serong kidal merah",
  "block.minecraft.banner.diagonal_left.white": "Paroeh serong kidal poetih",
  "block.minecraft.banner.diagonal_left.yellow": "Paroeh serong kidal koening",
  "block.minecraft.banner.diagonal_right.black": "Paroeh serong hitam",
  "block.minecraft.banner.diagonal_right.blue": "Paroeh serong biroe",
  "block.minecraft.banner.diagonal_right.brown": "Paroeh serong sawo matang",
  "block.minecraft.banner.diagonal_right.cyan": "Paroeh serong nilangsoeka",
  "block.minecraft.banner.diagonal_right.gray": "Paroeh serong kelaboe",
  "block.minecraft.banner.diagonal_right.green": "Paroeh serong hidjau",
  "block.minecraft.banner.diagonal_right.light_blue": "Paroeh serong biroe moeda",
  "block.minecraft.banner.diagonal_right.light_gray": "Paroeh serong kelaboe moeda",
  "block.minecraft.banner.diagonal_right.lime": "Paroeh serong hidjau poepoes",
  "block.minecraft.banner.diagonal_right.magenta": "Paroeh serong patma",
  "block.minecraft.banner.diagonal_right.orange": "Paroeh serong oranje",
  "block.minecraft.banner.diagonal_right.pink": "Paroeh serong djambon",
  "block.minecraft.banner.diagonal_right.purple": "Paroeh serong oengoe",
  "block.minecraft.banner.diagonal_right.red": "Paroeh serong merah",
  "block.minecraft.banner.diagonal_right.white": "Paroeh serong poetih",
  "block.minecraft.banner.diagonal_right.yellow": "Paroeh serong koening",
  "block.minecraft.banner.diagonal_up_left.black": "Paroeh serong soengsang hitam",
  "block.minecraft.banner.diagonal_up_left.blue": "Paroeh serong soengsang biroe",
  "block.minecraft.banner.diagonal_up_left.brown": "Paroeh serong soengsang sawo matang",
  "block.minecraft.banner.diagonal_up_left.cyan": "Paroeh serong soengsang nilangsoeka",
  "block.minecraft.banner.diagonal_up_left.gray": "Paroeh serong soengsang kelaboe",
  "block.minecraft.banner.diagonal_up_left.green": "Paroeh serong soengsang hidjau",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Paroeh serong soengsang biroe moeda",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Paroeh serong soengsang kelaboe moeda",
  "block.minecraft.banner.diagonal_up_left.lime": "Paroeh serong soengsang hidjau poepoes",
  "block.minecraft.banner.diagonal_up_left.magenta": "Paroeh serong soengsang patma",
  "block.minecraft.banner.diagonal_up_left.orange": "Paroeh serong soengsang oranje",
  "block.minecraft.banner.diagonal_up_left.pink": "Paroeh serong soengsang djambon",
  "block.minecraft.banner.diagonal_up_left.purple": "Paroeh serong soengsang oengoe",
  "block.minecraft.banner.diagonal_up_left.red": "Paroeh serong soengsang merah",
  "block.minecraft.banner.diagonal_up_left.white": "Paroeh serong soengsang poetih",
  "block.minecraft.banner.diagonal_up_left.yellow": "Paroeh serong soengsang koening",
  "block.minecraft.banner.diagonal_up_right.black": "Paroeh serong kidal soengsang hitam",
  "block.minecraft.banner.diagonal_up_right.blue": "Paroeh serong kidal soengsang biroe",
  "block.minecraft.banner.diagonal_up_right.brown": "Paroeh serong kidal soengsang sawo matang",
  "block.minecraft.banner.diagonal_up_right.cyan": "Paroeh serong kidal soengsang nilangsoeka",
  "block.minecraft.banner.diagonal_up_right.gray": "Paroeh serong kidal soengsang kelaboe",
  "block.minecraft.banner.diagonal_up_right.green": "Paroeh serong kidal soengsang hidjau",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Paroeh serong kidal soengsang biroe moeda",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Paroeh serong kidal soengsang kelaboe moeda",
  "block.minecraft.banner.diagonal_up_right.lime": "Paroeh serong kidal soengsang hidjau poepoes",
  "block.minecraft.banner.diagonal_up_right.magenta": "Paroeh serong kidal soengsang patma",
  "block.minecraft.banner.diagonal_up_right.orange": "Paroeh serong kidal soengsang oranje",
  "block.minecraft.banner.diagonal_up_right.pink": "Paroeh serong kidal soengsang djambon",
  "block.minecraft.banner.diagonal_up_right.purple": "Paroeh serong kidal soengsang oengoe",
  "block.minecraft.banner.diagonal_up_right.red": "Paroeh serong kidal soengsang merah",
  "block.minecraft.banner.diagonal_up_right.white": "Paroeh serong kidal soengsang poetih",
  "block.minecraft.banner.diagonal_up_right.yellow": "Paroeh serong kidal soengsang koening",
  "block.minecraft.banner.flow.black": "Pilin hitam",
  "block.minecraft.banner.flow.blue": "Pilin biroe",
  "block.minecraft.banner.flow.brown": "Pilin sawo matang",
  "block.minecraft.banner.flow.cyan": "Pilin nilangsoeka",
  "block.minecraft.banner.flow.gray": "Pilin kelaboe",
  "block.minecraft.banner.flow.green": "Pilin hidjau",
  "block.minecraft.banner.flow.light_blue": "Pilin biroe moeda",
  "block.minecraft.banner.flow.light_gray": "Pilin kelaboe moeda",
  "block.minecraft.banner.flow.lime": "Pilin hidjau poepoes",
  "block.minecraft.banner.flow.magenta": "Pilin patma",
  "block.minecraft.banner.flow.orange": "Pilin oranje",
  "block.minecraft.banner.flow.pink": "Pilin djambon",
  "block.minecraft.banner.flow.purple": "Pilin oengoe",
  "block.minecraft.banner.flow.red": "Pilin merah",
  "block.minecraft.banner.flow.white": "Pilin poetih",
  "block.minecraft.banner.flow.yellow": "Pilin koening",
  "block.minecraft.banner.flower.black": "Roepa boenga hitam",
  "block.minecraft.banner.flower.blue": "Roepa boenga biroe",
  "block.minecraft.banner.flower.brown": "Roepa boenga sawo matang",
  "block.minecraft.banner.flower.cyan": "Roepa boenga nilangsoeka",
  "block.minecraft.banner.flower.gray": "Roepa boenga kelaboe",
  "block.minecraft.banner.flower.green": "Roepa boenga hidjau",
  "block.minecraft.banner.flower.light_blue": "Roepa boenga biroe moeda",
  "block.minecraft.banner.flower.light_gray": "Roepa boenga kelaboe moeda",
  "block.minecraft.banner.flower.lime": "Roepa boenga hidjau poepoes",
  "block.minecraft.banner.flower.magenta": "Roepa boenga patma",
  "block.minecraft.banner.flower.orange": "Roepa boenga oranje",
  "block.minecraft.banner.flower.pink": "Roepa boenga djambon",
  "block.minecraft.banner.flower.purple": "Roepa boenga oengoe",
  "block.minecraft.banner.flower.red": "Roepa boenga merah",
  "block.minecraft.banner.flower.white": "Roepa boenga poetih",
  "block.minecraft.banner.flower.yellow": "Roepa boenga koening",
  "block.minecraft.banner.globe.black": "Globe hitam",
  "block.minecraft.banner.globe.blue": "Globe biroe",
  "block.minecraft.banner.globe.brown": "Globe sawo matang",
  "block.minecraft.banner.globe.cyan": "Globe nilangsoeka",
  "block.minecraft.banner.globe.gray": "Globe kelaboe",
  "block.minecraft.banner.globe.green": "Globe hidjau",
  "block.minecraft.banner.globe.light_blue": "Globe biroe moeda",
  "block.minecraft.banner.globe.light_gray": "Globe kelaboe moeda",
  "block.minecraft.banner.globe.lime": "Globe hidjau poepoes",
  "block.minecraft.banner.globe.magenta": "Globe patma",
  "block.minecraft.banner.globe.orange": "Globe oranje",
  "block.minecraft.banner.globe.pink": "Globe djambon",
  "block.minecraft.banner.globe.purple": "Globe oengoe",
  "block.minecraft.banner.globe.red": "Globe merah",
  "block.minecraft.banner.globe.white": "Globe poetih",
  "block.minecraft.banner.globe.yellow": "Globe koening",
  "block.minecraft.banner.gradient.black": "Gradasi hitam",
  "block.minecraft.banner.gradient.blue": "Gradasi biroe",
  "block.minecraft.banner.gradient.brown": "Gradasi sawo matang",
  "block.minecraft.banner.gradient.cyan": "Gradasi nilangsoeka",
  "block.minecraft.banner.gradient.gray": "Gradasi kelaboe",
  "block.minecraft.banner.gradient.green": "Gradasi hidjau",
  "block.minecraft.banner.gradient.light_blue": "Gradasi biroe moeda",
  "block.minecraft.banner.gradient.light_gray": "Gradasi kelaboe moeda",
  "block.minecraft.banner.gradient.lime": "Gradasi hidjau poepoes",
  "block.minecraft.banner.gradient.magenta": "Gradasi patma",
  "block.minecraft.banner.gradient.orange": "Gradasi oranje",
  "block.minecraft.banner.gradient.pink": "Gradasi djambon",
  "block.minecraft.banner.gradient.purple": "Gradasi oengoe",
  "block.minecraft.banner.gradient.red": "Gradasi merah",
  "block.minecraft.banner.gradient.white": "Gradasi poetih",
  "block.minecraft.banner.gradient.yellow": "Gradasi koening",
  "block.minecraft.banner.gradient_up.black": "Gradasi dasar hitam",
  "block.minecraft.banner.gradient_up.blue": "Gradasi dasar biroe",
  "block.minecraft.banner.gradient_up.brown": "Gradasi dasar sawo matang",
  "block.minecraft.banner.gradient_up.cyan": "Gradasi dasar nilangsoeka",
  "block.minecraft.banner.gradient_up.gray": "Gradasi dasar kelaboe",
  "block.minecraft.banner.gradient_up.green": "Gradasi dasar hidjau",
  "block.minecraft.banner.gradient_up.light_blue": "Gradasi dasar biroe moeda",
  "block.minecraft.banner.gradient_up.light_gray": "Gradasi dasar kelaboe moeda",
  "block.minecraft.banner.gradient_up.lime": "Gradasi dasar hidjau poepoes",
  "block.minecraft.banner.gradient_up.magenta": "Gradasi dasar patma",
  "block.minecraft.banner.gradient_up.orange": "Gradasi dasar oranje",
  "block.minecraft.banner.gradient_up.pink": "Gradasi dasar djambon",
  "block.minecraft.banner.gradient_up.purple": "Gradasi dasar oengoe",
  "block.minecraft.banner.gradient_up.red": "Gradasi dasar merah",
  "block.minecraft.banner.gradient_up.white": "Gradasi dasar poetih",
  "block.minecraft.banner.gradient_up.yellow": "Gradasi dasar koening",
  "block.minecraft.banner.guster.black": "Prahara hitam",
  "block.minecraft.banner.guster.blue": "Prahara biroe",
  "block.minecraft.banner.guster.brown": "Prahara sawo matang",
  "block.minecraft.banner.guster.cyan": "Prahara nilangsoeka",
  "block.minecraft.banner.guster.gray": "Prahara kelaboe",
  "block.minecraft.banner.guster.green": "Prahara hidjau",
  "block.minecraft.banner.guster.light_blue": "Prahara biroe moeda",
  "block.minecraft.banner.guster.light_gray": "Prahara kelaboe moeda",
  "block.minecraft.banner.guster.lime": "Prahara hidjau poepoes",
  "block.minecraft.banner.guster.magenta": "Prahara patma",
  "block.minecraft.banner.guster.orange": "Prahara oranje",
  "block.minecraft.banner.guster.pink": "Prahara djambon",
  "block.minecraft.banner.guster.purple": "Prahara oengoe",
  "block.minecraft.banner.guster.red": "Prahara merah",
  "block.minecraft.banner.guster.white": "Prahara poetih",
  "block.minecraft.banner.guster.yellow": "Prahara koening",
  "block.minecraft.banner.half_horizontal.black": "Paroeh lintang hitam",
  "block.minecraft.banner.half_horizontal.blue": "Paroeh lintang biroe",
  "block.minecraft.banner.half_horizontal.brown": "Paroeh lintang sawo matang",
  "block.minecraft.banner.half_horizontal.cyan": "Paroeh lintang nilangsoeka",
  "block.minecraft.banner.half_horizontal.gray": "Paroeh lintang kelaboe",
  "block.minecraft.banner.half_horizontal.green": "Paroeh lintang hidjau",
  "block.minecraft.banner.half_horizontal.light_blue": "Paroeh lintang biroe moeda",
  "block.minecraft.banner.half_horizontal.light_gray": "Paroeh lintang kelaboe moeda",
  "block.minecraft.banner.half_horizontal.lime": "Paroeh lintang hidjau poepoes",
  "block.minecraft.banner.half_horizontal.magenta": "Paroeh lintang patma",
  "block.minecraft.banner.half_horizontal.orange": "Paroeh lintang oranje",
  "block.minecraft.banner.half_horizontal.pink": "Paroeh lintang djambon",
  "block.minecraft.banner.half_horizontal.purple": "Paroeh lintang oengoe",
  "block.minecraft.banner.half_horizontal.red": "Paroeh lintang merah",
  "block.minecraft.banner.half_horizontal.white": "Paroeh lintang poetih",
  "block.minecraft.banner.half_horizontal.yellow": "Paroeh lintang koening",
  "block.minecraft.banner.half_horizontal_bottom.black": "Paroeh lintang soengsang hitam",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Paroeh lintang soengsang biroe",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Paroeh lintang soengsang sawo matang",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Paroeh lintang soengsang nilangsoeka",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Paroeh lintang soengsang kelaboe",
  "block.minecraft.banner.half_horizontal_bottom.green": "Paroeh lintang soengsang hidjau",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Paroeh lintang soengsang biroe moeda",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Paroeh lintang soengsang kelaboe moeda",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Paroeh lintang soengsang hidjau poepoes",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Paroeh lintang soengsang patma",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Paroeh lintang soengsang oranje",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Paroeh lintang soengsang djambon",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Paroeh lintang soengsang oengoe",
  "block.minecraft.banner.half_horizontal_bottom.red": "Paroeh lintang soengsang merah",
  "block.minecraft.banner.half_horizontal_bottom.white": "Paroeh lintang soengsang poetih",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Paroeh lintang soengsang koening",
  "block.minecraft.banner.half_vertical.black": "Paroeh boedjoer hitam",
  "block.minecraft.banner.half_vertical.blue": "Paroeh boedjoer biroe",
  "block.minecraft.banner.half_vertical.brown": "Paroeh boedjoer sawo matang",
  "block.minecraft.banner.half_vertical.cyan": "Paroeh boedjoer nilangsoeka",
  "block.minecraft.banner.half_vertical.gray": "Paroeh boedjoer kelaboe",
  "block.minecraft.banner.half_vertical.green": "Paroeh boedjoer hidjau",
  "block.minecraft.banner.half_vertical.light_blue": "Paroeh boedjoer biroe moeda",
  "block.minecraft.banner.half_vertical.light_gray": "Paroeh boedjoer kelaboe moeda",
  "block.minecraft.banner.half_vertical.lime": "Paroeh boedjoer hidjau poepoes",
  "block.minecraft.banner.half_vertical.magenta": "Paroeh boedjoer patma",
  "block.minecraft.banner.half_vertical.orange": "Paroeh boedjoer oranje",
  "block.minecraft.banner.half_vertical.pink": "Paroeh boedjoer djambon",
  "block.minecraft.banner.half_vertical.purple": "Paroeh boedjoer oengoe",
  "block.minecraft.banner.half_vertical.red": "Paroeh boedjoer merah",
  "block.minecraft.banner.half_vertical.white": "Paroeh boedjoer poetih",
  "block.minecraft.banner.half_vertical.yellow": "Paroeh boedjoer koening",
  "block.minecraft.banner.half_vertical_right.black": "Paroeh boedjoer soengsang hitam",
  "block.minecraft.banner.half_vertical_right.blue": "Paroeh boedjoer soengsang biroe",
  "block.minecraft.banner.half_vertical_right.brown": "Paroeh boedjoer soengsang sawo matang",
  "block.minecraft.banner.half_vertical_right.cyan": "Paroeh boedjoer soengsang nilangsoeka",
  "block.minecraft.banner.half_vertical_right.gray": "Paroeh boedjoer soengsang kelaboe",
  "block.minecraft.banner.half_vertical_right.green": "Paroeh boedjoer soengsang hidjau",
  "block.minecraft.banner.half_vertical_right.light_blue": "Paroeh boedjoer soengsang biroe moeda",
  "block.minecraft.banner.half_vertical_right.light_gray": "Paroeh boedjoer soengsang kelaboe moeda",
  "block.minecraft.banner.half_vertical_right.lime": "Paroeh boedjoer soengsang hidjau poepoes",
  "block.minecraft.banner.half_vertical_right.magenta": "Paroeh boedjoer soengsang patma",
  "block.minecraft.banner.half_vertical_right.orange": "Paroeh boedjoer soengsang oranje",
  "block.minecraft.banner.half_vertical_right.pink": "Paroeh boedjoer soengsang djambon",
  "block.minecraft.banner.half_vertical_right.purple": "Paroeh boedjoer soengsang oengoe",
  "block.minecraft.banner.half_vertical_right.red": "Paroeh boedjoer soengsang merah",
  "block.minecraft.banner.half_vertical_right.white": "Paroeh boedjoer soengsang poetih",
  "block.minecraft.banner.half_vertical_right.yellow": "Paroeh boedjoer soengsang koening",
  "block.minecraft.banner.mojang.black": "Lambang hitam",
  "block.minecraft.banner.mojang.blue": "Lambang biroe",
  "block.minecraft.banner.mojang.brown": "Lambang sawo matang",
  "block.minecraft.banner.mojang.cyan": "Lambang nilangsoeka",
  "block.minecraft.banner.mojang.gray": "Lambang kelaboe",
  "block.minecraft.banner.mojang.green": "Lambang hidjau",
  "block.minecraft.banner.mojang.light_blue": "Lambang biroe moeda",
  "block.minecraft.banner.mojang.light_gray": "Lambang kelaboe moeda",
  "block.minecraft.banner.mojang.lime": "Lambang hidjau poepoes",
  "block.minecraft.banner.mojang.magenta": "Lambang patma",
  "block.minecraft.banner.mojang.orange": "Lambang oranje",
  "block.minecraft.banner.mojang.pink": "Lambang djambon",
  "block.minecraft.banner.mojang.purple": "Lambang oengoe",
  "block.minecraft.banner.mojang.red": "Lambang merah",
  "block.minecraft.banner.mojang.white": "Lambang poetih",
  "block.minecraft.banner.mojang.yellow": "Lambang koening",
  "block.minecraft.banner.piglin.black": "Montjong hitam",
  "block.minecraft.banner.piglin.blue": "Montjong biroe",
  "block.minecraft.banner.piglin.brown": "Montjong sawo matang",
  "block.minecraft.banner.piglin.cyan": "Montjong nilangsoeka",
  "block.minecraft.banner.piglin.gray": "Montjong kelaboe",
  "block.minecraft.banner.piglin.green": "Montjong hidjau",
  "block.minecraft.banner.piglin.light_blue": "Montjong biroe moeda",
  "block.minecraft.banner.piglin.light_gray": "Montjong kelaboe moeda",
  "block.minecraft.banner.piglin.lime": "Montjong hidjau poepoes",
  "block.minecraft.banner.piglin.magenta": "Montjong patma",
  "block.minecraft.banner.piglin.orange": "Montjong oranje",
  "block.minecraft.banner.piglin.pink": "Montjong djambon",
  "block.minecraft.banner.piglin.purple": "Montjong oengoe",
  "block.minecraft.banner.piglin.red": "Montjong merah",
  "block.minecraft.banner.piglin.white": "Montjong poetih",
  "block.minecraft.banner.piglin.yellow": "Montjong koening",
  "block.minecraft.banner.rhombus.black": "Wadjik hitam",
  "block.minecraft.banner.rhombus.blue": "Wadjik biroe",
  "block.minecraft.banner.rhombus.brown": "Wadjik sawo matang",
  "block.minecraft.banner.rhombus.cyan": "Wadjik nilangsoeka",
  "block.minecraft.banner.rhombus.gray": "Wadjik kelaboe",
  "block.minecraft.banner.rhombus.green": "Wadjik hidjau",
  "block.minecraft.banner.rhombus.light_blue": "Wadjik biroe moeda",
  "block.minecraft.banner.rhombus.light_gray": "Wadjik kelaboe moeda",
  "block.minecraft.banner.rhombus.lime": "Wadjik hidjau poepoes",
  "block.minecraft.banner.rhombus.magenta": "Wadjik patma",
  "block.minecraft.banner.rhombus.orange": "Wadjik oranje",
  "block.minecraft.banner.rhombus.pink": "Wadjik djambon",
  "block.minecraft.banner.rhombus.purple": "Wadjik oengoe",
  "block.minecraft.banner.rhombus.red": "Wadjik merah",
  "block.minecraft.banner.rhombus.white": "Wadjik poetih",
  "block.minecraft.banner.rhombus.yellow": "Wadjik koening",
  "block.minecraft.banner.skull.black": "Roepa tengkorak hitam",
  "block.minecraft.banner.skull.blue": "Roepa tengkorak biroe",
  "block.minecraft.banner.skull.brown": "Roepa tengkorak sawo matang",
  "block.minecraft.banner.skull.cyan": "Roepa tengkorak nilangsoeka",
  "block.minecraft.banner.skull.gray": "Roepa tengkorak kelaboe",
  "block.minecraft.banner.skull.green": "Roepa tengkorak hidjau",
  "block.minecraft.banner.skull.light_blue": "Roepa tengkorak biroe moeda",
  "block.minecraft.banner.skull.light_gray": "Roepa tengkorak kelaboe moeda",
  "block.minecraft.banner.skull.lime": "Roepa tengkorak hidjau poepoes",
  "block.minecraft.banner.skull.magenta": "Roepa tengkorak patma",
  "block.minecraft.banner.skull.orange": "Roepa tengkorak oranje",
  "block.minecraft.banner.skull.pink": "Roepa tengkorak djambon",
  "block.minecraft.banner.skull.purple": "Roepa tengkorak oengoe",
  "block.minecraft.banner.skull.red": "Roepa tengkorak merah",
  "block.minecraft.banner.skull.white": "Roepa tengkorak poetih",
  "block.minecraft.banner.skull.yellow": "Roepa tengkorak koening",
  "block.minecraft.banner.small_stripes.black": "Tonggak-tonggak hitam",
  "block.minecraft.banner.small_stripes.blue": "Tonggak-tonggak biroe",
  "block.minecraft.banner.small_stripes.brown": "Tonggak-tonggak sawo matang",
  "block.minecraft.banner.small_stripes.cyan": "Tonggak-tonggak nilangsoeka",
  "block.minecraft.banner.small_stripes.gray": "Tonggak-tonggak kelaboe",
  "block.minecraft.banner.small_stripes.green": "Tonggak-tonggak hidjau",
  "block.minecraft.banner.small_stripes.light_blue": "Tonggak-tonggak biroe moeda",
  "block.minecraft.banner.small_stripes.light_gray": "Tonggak-tonggak kelaboe moeda",
  "block.minecraft.banner.small_stripes.lime": "Tonggak-tonggak hidjau poepoes",
  "block.minecraft.banner.small_stripes.magenta": "Tonggak-tonggak patma",
  "block.minecraft.banner.small_stripes.orange": "Tonggak-tonggak oranje",
  "block.minecraft.banner.small_stripes.pink": "Tonggak-tonggak djambon",
  "block.minecraft.banner.small_stripes.purple": "Tonggak-tonggak oengoe",
  "block.minecraft.banner.small_stripes.red": "Tonggak-tonggak merah",
  "block.minecraft.banner.small_stripes.white": "Tonggak-tonggak poetih",
  "block.minecraft.banner.small_stripes.yellow": "Tonggak-tonggak koening",
  "block.minecraft.banner.square_bottom_left.black": "Petak dasar kinan hitam",
  "block.minecraft.banner.square_bottom_left.blue": "Petak dasar kinan biroe",
  "block.minecraft.banner.square_bottom_left.brown": "Petak dasar kinan sawo matang",
  "block.minecraft.banner.square_bottom_left.cyan": "Petak dasar kinan nilangsoeka",
  "block.minecraft.banner.square_bottom_left.gray": "Petak dasar kinan kelaboe",
  "block.minecraft.banner.square_bottom_left.green": "Petak dasar kinan hidjau",
  "block.minecraft.banner.square_bottom_left.light_blue": "Petak dasar kinan biroe moeda",
  "block.minecraft.banner.square_bottom_left.light_gray": "Petak dasar kinan kelaboe moeda",
  "block.minecraft.banner.square_bottom_left.lime": "Petak dasar kinan hidjau poepoes",
  "block.minecraft.banner.square_bottom_left.magenta": "Petak dasar kinan patma",
  "block.minecraft.banner.square_bottom_left.orange": "Petak dasar kinan oranje",
  "block.minecraft.banner.square_bottom_left.pink": "Petak dasar kinan djambon",
  "block.minecraft.banner.square_bottom_left.purple": "Petak dasar kinan oengoe",
  "block.minecraft.banner.square_bottom_left.red": "Petak dasar kinan merah",
  "block.minecraft.banner.square_bottom_left.white": "Petak dasar kinan poetih",
  "block.minecraft.banner.square_bottom_left.yellow": "Petak dasar kinan koening",
  "block.minecraft.banner.square_bottom_right.black": "Petak dasar kidal hitam",
  "block.minecraft.banner.square_bottom_right.blue": "Petak dasar kidal biroe",
  "block.minecraft.banner.square_bottom_right.brown": "Petak dasar kidal sawo matang",
  "block.minecraft.banner.square_bottom_right.cyan": "Petak dasar kidal nilangsoeka",
  "block.minecraft.banner.square_bottom_right.gray": "Petak dasar kidal kelaboe",
  "block.minecraft.banner.square_bottom_right.green": "Petak dasar kidal hidjau",
  "block.minecraft.banner.square_bottom_right.light_blue": "Petak dasar kidal biroe moeda",
  "block.minecraft.banner.square_bottom_right.light_gray": "Petak dasar kidal kelaboe moeda",
  "block.minecraft.banner.square_bottom_right.lime": "Petak dasar kidal hidjau poepoes",
  "block.minecraft.banner.square_bottom_right.magenta": "Petak dasar kidal patma",
  "block.minecraft.banner.square_bottom_right.orange": "Petak dasar kidal oranje",
  "block.minecraft.banner.square_bottom_right.pink": "Petak dasar kidal djambon",
  "block.minecraft.banner.square_bottom_right.purple": "Petak dasar kidal oengoe",
  "block.minecraft.banner.square_bottom_right.red": "Petak dasar kidal merah",
  "block.minecraft.banner.square_bottom_right.white": "Petak dasar kidal poetih",
  "block.minecraft.banner.square_bottom_right.yellow": "Petak dasar kidal koening",
  "block.minecraft.banner.square_top_left.black": "Petak hoeloe kinan hitam",
  "block.minecraft.banner.square_top_left.blue": "Petak hoeloe kinan biroe",
  "block.minecraft.banner.square_top_left.brown": "Petak hoeloe kinan sawo matang",
  "block.minecraft.banner.square_top_left.cyan": "Petak hoeloe kinan nilangsoeka",
  "block.minecraft.banner.square_top_left.gray": "Petak hoeloe kinan kelaboe",
  "block.minecraft.banner.square_top_left.green": "Petak hoeloe kinan hidjau",
  "block.minecraft.banner.square_top_left.light_blue": "Petak hoeloe kinan biroe moeda",
  "block.minecraft.banner.square_top_left.light_gray": "Petak hoeloe kinan kelaboe moeda",
  "block.minecraft.banner.square_top_left.lime": "Petak hoeloe kinan hidjau poepoes",
  "block.minecraft.banner.square_top_left.magenta": "Petak hoeloe kinan patma",
  "block.minecraft.banner.square_top_left.orange": "Petak hoeloe kinan oranje",
  "block.minecraft.banner.square_top_left.pink": "Petak hoeloe kinan djambon",
  "block.minecraft.banner.square_top_left.purple": "Petak hoeloe kinan oengoe",
  "block.minecraft.banner.square_top_left.red": "Petak hoeloe kinan merah",
  "block.minecraft.banner.square_top_left.white": "Petak hoeloe kinan poetih",
  "block.minecraft.banner.square_top_left.yellow": "Petak hoeloe kinan koening",
  "block.minecraft.banner.square_top_right.black": "Petak hoeloe kidal hitam",
  "block.minecraft.banner.square_top_right.blue": "Petak hoeloe kidal biroe",
  "block.minecraft.banner.square_top_right.brown": "Petak hoeloe kidal sawo matang",
  "block.minecraft.banner.square_top_right.cyan": "Petak hoeloe kidal nilangsoeka",
  "block.minecraft.banner.square_top_right.gray": "Petak hoeloe kidal kelaboe",
  "block.minecraft.banner.square_top_right.green": "Petak hoeloe kidal hidjau",
  "block.minecraft.banner.square_top_right.light_blue": "Petak hoeloe kidal biroe moeda",
  "block.minecraft.banner.square_top_right.light_gray": "Petak hoeloe kidal kelaboe moeda",
  "block.minecraft.banner.square_top_right.lime": "Petak hoeloe kidal hidjau poepoes",
  "block.minecraft.banner.square_top_right.magenta": "Petak hoeloe kidal patma",
  "block.minecraft.banner.square_top_right.orange": "Petak hoeloe kidal oranje",
  "block.minecraft.banner.square_top_right.pink": "Petak hoeloe kidal djambon",
  "block.minecraft.banner.square_top_right.purple": "Petak hoeloe kidal oengoe",
  "block.minecraft.banner.square_top_right.red": "Petak hoeloe kidal merah",
  "block.minecraft.banner.square_top_right.white": "Petak hoeloe kidal poetih",
  "block.minecraft.banner.square_top_right.yellow": "Petak hoeloe kidal koening",
  "block.minecraft.banner.straight_cross.black": "Palang hitam",
  "block.minecraft.banner.straight_cross.blue": "Palang biroe",
  "block.minecraft.banner.straight_cross.brown": "Palang sawo matang",
  "block.minecraft.banner.straight_cross.cyan": "Palang nilangsoeka",
  "block.minecraft.banner.straight_cross.gray": "Palang kelaboe",
  "block.minecraft.banner.straight_cross.green": "Palang hidjau",
  "block.minecraft.banner.straight_cross.light_blue": "Palang biroe moeda",
  "block.minecraft.banner.straight_cross.light_gray": "Palang kelaboe moeda",
  "block.minecraft.banner.straight_cross.lime": "Palang hidjau poepoes",
  "block.minecraft.banner.straight_cross.magenta": "Palang patma",
  "block.minecraft.banner.straight_cross.orange": "Palang oranje",
  "block.minecraft.banner.straight_cross.pink": "Palang djambon",
  "block.minecraft.banner.straight_cross.purple": "Palang oengoe",
  "block.minecraft.banner.straight_cross.red": "Palang merah",
  "block.minecraft.banner.straight_cross.white": "Palang poetih",
  "block.minecraft.banner.straight_cross.yellow": "Palang koening",
  "block.minecraft.banner.stripe_bottom.black": "Dasar hitam",
  "block.minecraft.banner.stripe_bottom.blue": "Dasar biroe",
  "block.minecraft.banner.stripe_bottom.brown": "Dasar sawo matang",
  "block.minecraft.banner.stripe_bottom.cyan": "Dasar nilangsoeka",
  "block.minecraft.banner.stripe_bottom.gray": "Dasar kelaboe",
  "block.minecraft.banner.stripe_bottom.green": "Dasar hidjau",
  "block.minecraft.banner.stripe_bottom.light_blue": "Dasar biroe moeda",
  "block.minecraft.banner.stripe_bottom.light_gray": "Dasar kelaboe moeda",
  "block.minecraft.banner.stripe_bottom.lime": "Dasar hidjau poepoes",
  "block.minecraft.banner.stripe_bottom.magenta": "Dasar patma",
  "block.minecraft.banner.stripe_bottom.orange": "Dasar oranje",
  "block.minecraft.banner.stripe_bottom.pink": "Dasar djambon",
  "block.minecraft.banner.stripe_bottom.purple": "Dasar oengoe",
  "block.minecraft.banner.stripe_bottom.red": "Dasar merah",
  "block.minecraft.banner.stripe_bottom.white": "Dasar poetih",
  "block.minecraft.banner.stripe_bottom.yellow": "Dasar koening",
  "block.minecraft.banner.stripe_center.black": "Tonggak hitam",
  "block.minecraft.banner.stripe_center.blue": "Tonggak biroe",
  "block.minecraft.banner.stripe_center.brown": "Tonggak sawo matang",
  "block.minecraft.banner.stripe_center.cyan": "Tonggak nilangsoeka",
  "block.minecraft.banner.stripe_center.gray": "Tonggak kelaboe",
  "block.minecraft.banner.stripe_center.green": "Tonggak hidjau",
  "block.minecraft.banner.stripe_center.light_blue": "Tonggak biroe moeda",
  "block.minecraft.banner.stripe_center.light_gray": "Tonggak kelaboe moeda",
  "block.minecraft.banner.stripe_center.lime": "Tonggak hidjau poepoes",
  "block.minecraft.banner.stripe_center.magenta": "Tonggak patma",
  "block.minecraft.banner.stripe_center.orange": "Tonggak oranje",
  "block.minecraft.banner.stripe_center.pink": "Tonggak djambon",
  "block.minecraft.banner.stripe_center.purple": "Tonggak oengoe",
  "block.minecraft.banner.stripe_center.red": "Tonggak merah",
  "block.minecraft.banner.stripe_center.white": "Tonggak poetih",
  "block.minecraft.banner.stripe_center.yellow": "Tonggak koening",
  "block.minecraft.banner.stripe_downleft.black": "Serongan kidal hitam",
  "block.minecraft.banner.stripe_downleft.blue": "Serongan kidal biroe",
  "block.minecraft.banner.stripe_downleft.brown": "Serongan kidal sawo matang",
  "block.minecraft.banner.stripe_downleft.cyan": "Serongan kidal nilangsoeka",
  "block.minecraft.banner.stripe_downleft.gray": "Serongan kidal kelaboe",
  "block.minecraft.banner.stripe_downleft.green": "Serongan kidal hidjau",
  "block.minecraft.banner.stripe_downleft.light_blue": "Serongan kidal biroe moeda",
  "block.minecraft.banner.stripe_downleft.light_gray": "Serongan kidal kelaboe moeda",
  "block.minecraft.banner.stripe_downleft.lime": "Serongan kidal hidjau poepoes",
  "block.minecraft.banner.stripe_downleft.magenta": "Serongan kidal patma",
  "block.minecraft.banner.stripe_downleft.orange": "Serongan kidal oranje",
  "block.minecraft.banner.stripe_downleft.pink": "Serongan kidal djambon",
  "block.minecraft.banner.stripe_downleft.purple": "Serongan kidal oengoe",
  "block.minecraft.banner.stripe_downleft.red": "Serongan kidal merah",
  "block.minecraft.banner.stripe_downleft.white": "Serongan kidal poetih",
  "block.minecraft.banner.stripe_downleft.yellow": "Serongan kidal koening",
  "block.minecraft.banner.stripe_downright.black": "Serongan hitam",
  "block.minecraft.banner.stripe_downright.blue": "Serongan biroe",
  "block.minecraft.banner.stripe_downright.brown": "Serongan pirang",
  "block.minecraft.banner.stripe_downright.cyan": "Serongan nilangsoeka",
  "block.minecraft.banner.stripe_downright.gray": "Serongan kelaboe",
  "block.minecraft.banner.stripe_downright.green": "Serongan hidjau",
  "block.minecraft.banner.stripe_downright.light_blue": "Serongan biroe moeda",
  "block.minecraft.banner.stripe_downright.light_gray": "Serongan kelaboe moeda",
  "block.minecraft.banner.stripe_downright.lime": "Serongan hidjau poepoes",
  "block.minecraft.banner.stripe_downright.magenta": "Serongan patma",
  "block.minecraft.banner.stripe_downright.orange": "Serongan oranje",
  "block.minecraft.banner.stripe_downright.pink": "Serongan djambon",
  "block.minecraft.banner.stripe_downright.purple": "Serongan oengoe",
  "block.minecraft.banner.stripe_downright.red": "Serongan merah",
  "block.minecraft.banner.stripe_downright.white": "Serongan poetih",
  "block.minecraft.banner.stripe_downright.yellow": "Serongan koening",
  "block.minecraft.banner.stripe_left.black": "Tonggak kinan hitam",
  "block.minecraft.banner.stripe_left.blue": "Tonggak kinan biroe",
  "block.minecraft.banner.stripe_left.brown": "Tonggak kinan sawo matang",
  "block.minecraft.banner.stripe_left.cyan": "Tonggak kinan nilangsoeka",
  "block.minecraft.banner.stripe_left.gray": "Tonggak kinan kelaboe",
  "block.minecraft.banner.stripe_left.green": "Tonggak kinan hidjau",
  "block.minecraft.banner.stripe_left.light_blue": "Tonggak kinan biroe moeda",
  "block.minecraft.banner.stripe_left.light_gray": "Tonggak kinan kelaboe moeda",
  "block.minecraft.banner.stripe_left.lime": "Tonggak kinan hidjau poepoes",
  "block.minecraft.banner.stripe_left.magenta": "Tonggak kinan patma",
  "block.minecraft.banner.stripe_left.orange": "Tonggak kinan oranje",
  "block.minecraft.banner.stripe_left.pink": "Tonggak kinan djambon",
  "block.minecraft.banner.stripe_left.purple": "Tonggak kinan oengoe",
  "block.minecraft.banner.stripe_left.red": "Tonggak kinan merah",
  "block.minecraft.banner.stripe_left.white": "Tonggak kinan poetih",
  "block.minecraft.banner.stripe_left.yellow": "Tonggak kinan koening",
  "block.minecraft.banner.stripe_middle.black": "Djaloer hitam",
  "block.minecraft.banner.stripe_middle.blue": "Djaloer biroe",
  "block.minecraft.banner.stripe_middle.brown": "Djaloer sawo matang",
  "block.minecraft.banner.stripe_middle.cyan": "Djaloer nilangsoeka",
  "block.minecraft.banner.stripe_middle.gray": "Djaloer kelaboe",
  "block.minecraft.banner.stripe_middle.green": "Djaloer hidjau",
  "block.minecraft.banner.stripe_middle.light_blue": "Djaloer biroe moeda",
  "block.minecraft.banner.stripe_middle.light_gray": "Djaloer kelaboe moeda",
  "block.minecraft.banner.stripe_middle.lime": "Djaloer hidjau poepoes",
  "block.minecraft.banner.stripe_middle.magenta": "Djaloer patma",
  "block.minecraft.banner.stripe_middle.orange": "Djaloer oranje",
  "block.minecraft.banner.stripe_middle.pink": "Djaloer djambon",
  "block.minecraft.banner.stripe_middle.purple": "Djaloer oengoe",
  "block.minecraft.banner.stripe_middle.red": "Djaloer merah",
  "block.minecraft.banner.stripe_middle.white": "Djaloer poetih",
  "block.minecraft.banner.stripe_middle.yellow": "Djaloer koening",
  "block.minecraft.banner.stripe_right.black": "Tonggak kidal hitam",
  "block.minecraft.banner.stripe_right.blue": "Tonggak kidal biroe",
  "block.minecraft.banner.stripe_right.brown": "Tonggak kidal sawo matang",
  "block.minecraft.banner.stripe_right.cyan": "Tonggak kidal nilangsoeka",
  "block.minecraft.banner.stripe_right.gray": "Tonggak kidal kelaboe",
  "block.minecraft.banner.stripe_right.green": "Tonggak kidal hidjau",
  "block.minecraft.banner.stripe_right.light_blue": "Tonggak kidal biroe moeda",
  "block.minecraft.banner.stripe_right.light_gray": "Tonggak kidal kelaboe moeda\n",
  "block.minecraft.banner.stripe_right.lime": "Tonggak kidal hidjau poepoes",
  "block.minecraft.banner.stripe_right.magenta": "Tonggak kidal patma",
  "block.minecraft.banner.stripe_right.orange": "Tonggak kidal oranje",
  "block.minecraft.banner.stripe_right.pink": "Tonggak kidal djambon",
  "block.minecraft.banner.stripe_right.purple": "Tonggak kidal oengoe",
  "block.minecraft.banner.stripe_right.red": "Tonggak kidal merah",
  "block.minecraft.banner.stripe_right.white": "Tonggak kidal poetih",
  "block.minecraft.banner.stripe_right.yellow": "Tonggak kidal kuning",
  "block.minecraft.banner.stripe_top.black": "Hoeloe hitam",
  "block.minecraft.banner.stripe_top.blue": "Hoeloe biroe",
  "block.minecraft.banner.stripe_top.brown": "Hoeloe sawo matang",
  "block.minecraft.banner.stripe_top.cyan": "Hoeloe nilangsoeka",
  "block.minecraft.banner.stripe_top.gray": "Hoeloe kelaboe",
  "block.minecraft.banner.stripe_top.green": "Hoeloe hidjau",
  "block.minecraft.banner.stripe_top.light_blue": "Hoeloe biroe moeda",
  "block.minecraft.banner.stripe_top.light_gray": "Hoeloe kelaboe moeda",
  "block.minecraft.banner.stripe_top.lime": "Hoeloe hidjau poepoes",
  "block.minecraft.banner.stripe_top.magenta": "Hoeloe patma",
  "block.minecraft.banner.stripe_top.orange": "Hoeloe oranje",
  "block.minecraft.banner.stripe_top.pink": "Hoeloe djambon",
  "block.minecraft.banner.stripe_top.purple": "Hoeloe oengoe",
  "block.minecraft.banner.stripe_top.red": "Hoeloe merah",
  "block.minecraft.banner.stripe_top.white": "Hoeloe poetih",
  "block.minecraft.banner.stripe_top.yellow": "Hoeloe koening",
  "block.minecraft.banner.triangle_bottom.black": "Takoek hitam",
  "block.minecraft.banner.triangle_bottom.blue": "Takoek biroe",
  "block.minecraft.banner.triangle_bottom.brown": "Takoek sawo matang",
  "block.minecraft.banner.triangle_bottom.cyan": "Takoek nilangsoeka",
  "block.minecraft.banner.triangle_bottom.gray": "Takoek kelaboe",
  "block.minecraft.banner.triangle_bottom.green": "Takoek hidjau",
  "block.minecraft.banner.triangle_bottom.light_blue": "Takoek biroe moeda",
  "block.minecraft.banner.triangle_bottom.light_gray": "Takoek kelaboe moeda",
  "block.minecraft.banner.triangle_bottom.lime": "Takoek hidjau poepoes",
  "block.minecraft.banner.triangle_bottom.magenta": "Takoek patma",
  "block.minecraft.banner.triangle_bottom.orange": "Takoek oranje",
  "block.minecraft.banner.triangle_bottom.pink": "Takoek djambon",
  "block.minecraft.banner.triangle_bottom.purple": "Takoek oengoe",
  "block.minecraft.banner.triangle_bottom.red": "Takoek merah",
  "block.minecraft.banner.triangle_bottom.white": "Takoek poetih",
  "block.minecraft.banner.triangle_bottom.yellow": "Takoek koening",
  "block.minecraft.banner.triangle_top.black": "Takoek soengsang hitam",
  "block.minecraft.banner.triangle_top.blue": "Takoek soengsang biroe",
  "block.minecraft.banner.triangle_top.brown": "Takoek soengsang sawo matang",
  "block.minecraft.banner.triangle_top.cyan": "Takoek soengsang nilangsoeka",
  "block.minecraft.banner.triangle_top.gray": "Takoek soengsang kelaboe",
  "block.minecraft.banner.triangle_top.green": "Takoek soengsang hidjau",
  "block.minecraft.banner.triangle_top.light_blue": "Takoek soengsang biroe moeda",
  "block.minecraft.banner.triangle_top.light_gray": "Takoek soengsang kelaboe moeda",
  "block.minecraft.banner.triangle_top.lime": "Takoek soengsang hidjau poepoes",
  "block.minecraft.banner.triangle_top.magenta": "Takoek soengsang patma",
  "block.minecraft.banner.triangle_top.orange": "Takoek soengsang oranje",
  "block.minecraft.banner.triangle_top.pink": "Takoek soengsang djambon",
  "block.minecraft.banner.triangle_top.purple": "Takoek soengsang oengoe",
  "block.minecraft.banner.triangle_top.red": "Takoek soengsang merah",
  "block.minecraft.banner.triangle_top.white": "Takoek soengsang poetih",
  "block.minecraft.banner.triangle_top.yellow": "Takoek soengsang koening",
  "block.minecraft.banner.triangles_bottom.black": "Dasar bertakik hitam",
  "block.minecraft.banner.triangles_bottom.blue": "Dasar bertakik biroe",
  "block.minecraft.banner.triangles_bottom.brown": "Dasar bertakik sawo matang",
  "block.minecraft.banner.triangles_bottom.cyan": "Dasar bertakik nilangsoeka",
  "block.minecraft.banner.triangles_bottom.gray": "Dasar bertakik kelaboe",
  "block.minecraft.banner.triangles_bottom.green": "Dasar bertakik hidjau",
  "block.minecraft.banner.triangles_bottom.light_blue": "Dasar bertakik biroe moeda",
  "block.minecraft.banner.triangles_bottom.light_gray": "Dasar bertakik kelaboe moeda",
  "block.minecraft.banner.triangles_bottom.lime": "Dasar bertakik hidjau poepoes",
  "block.minecraft.banner.triangles_bottom.magenta": "Dasar bertakik patma",
  "block.minecraft.banner.triangles_bottom.orange": "Dasar bertakik oranje",
  "block.minecraft.banner.triangles_bottom.pink": "Dasar bertakik djambon",
  "block.minecraft.banner.triangles_bottom.purple": "Dasar bertakik oengoe",
  "block.minecraft.banner.triangles_bottom.red": "Dasar bertakik merah",
  "block.minecraft.banner.triangles_bottom.white": "Dasar bertakik poetih",
  "block.minecraft.banner.triangles_bottom.yellow": "Dasar bertakik koening",
  "block.minecraft.banner.triangles_top.black": "Hoeloe bertakik hitam",
  "block.minecraft.banner.triangles_top.blue": "Hoeloe bertakik biroe",
  "block.minecraft.banner.triangles_top.brown": "Hoeloe bertakik sawo matang",
  "block.minecraft.banner.triangles_top.cyan": "Hoeloe bertakik nilangsoeka",
  "block.minecraft.banner.triangles_top.gray": "Hoeloe bertakik kelaboe",
  "block.minecraft.banner.triangles_top.green": "Hoeloe bertakik hidjau",
  "block.minecraft.banner.triangles_top.light_blue": "Hoeloe bertakik biroe moeda",
  "block.minecraft.banner.triangles_top.light_gray": "Hoeloe bertakik kelaboe moeda",
  "block.minecraft.banner.triangles_top.lime": "Hoeloe bertakik hidjau poepoes",
  "block.minecraft.banner.triangles_top.magenta": "Hoeloe bertakik patma",
  "block.minecraft.banner.triangles_top.orange": "Hoeloe bertakik djambon",
  "block.minecraft.banner.triangles_top.pink": "Hoeloe bertakik djambon",
  "block.minecraft.banner.triangles_top.purple": "Hoeloe bertakik oengoe",
  "block.minecraft.banner.triangles_top.red": "Hoeloe bertakik merah",
  "block.minecraft.banner.triangles_top.white": "Hoeloe bertakik poetih",
  "block.minecraft.banner.triangles_top.yellow": "Hoeloe bertakik koening",
  "block.minecraft.barrel": "Tong",
  "block.minecraft.barrier": "Penghalang",
  "block.minecraft.basalt": "Basal",
  "block.minecraft.beacon": "Soear",
  "block.minecraft.beacon.primary": "Daja oetama",
  "block.minecraft.beacon.secondary": "Daja kedoea",
  "block.minecraft.bed.no_sleep": "Toean hanja boleh tidoer sa'at malam atau badai petir",
  "block.minecraft.bed.not_safe": "Toean tidak boleh tidoer sekarang karena ada monster dekat sini",
  "block.minecraft.bed.obstructed": "Katil ini terhalangi",
  "block.minecraft.bed.occupied": "Katil ini ditempati",
  "block.minecraft.bed.too_far_away": "Toean tidak boleh tidoer sekarang karena katil terlaloe djaoeh",
  "block.minecraft.bedrock": "Batoe dasar",
  "block.minecraft.bee_nest": "Sarang lebah",
  "block.minecraft.beehive": "Roemah lebah",
  "block.minecraft.beetroots": "Bit",
  "block.minecraft.bell": "Bel",
  "block.minecraft.big_dripleaf": "Daoen tetes besar",
  "block.minecraft.big_dripleaf_stem": "Batang daoen tetes besar",
  "block.minecraft.birch_button": "Kenop berk",
  "block.minecraft.birch_door": "Pintoe berk",
  "block.minecraft.birch_fence": "Pagar berk",
  "block.minecraft.birch_fence_gate": "Pintoe pagar berk",
  "block.minecraft.birch_hanging_sign": "Papan tanda gantoeng berk",
  "block.minecraft.birch_leaves": "Daoen berk",
  "block.minecraft.birch_log": "Gelondong berk",
  "block.minecraft.birch_planks": "Papan berk",
  "block.minecraft.birch_pressure_plate": "Pelat penekan berk",
  "block.minecraft.birch_sapling": "Bibit berk",
  "block.minecraft.birch_shelf": "Rak berk",
  "block.minecraft.birch_sign": "Papan tanda berk",
  "block.minecraft.birch_slab": "Pelat berk",
  "block.minecraft.birch_stairs": "Tangga berk",
  "block.minecraft.birch_trapdoor": "Pintoe kolong berk",
  "block.minecraft.birch_wall_hanging_sign": "Papan tanda gantoeng dinding berk",
  "block.minecraft.birch_wall_sign": "Papan tanda dinding berk",
  "block.minecraft.birch_wood": "Kajoe berk",
  "block.minecraft.black_banner": "Pandji hitam",
  "block.minecraft.black_bed": "Katil hitam",
  "block.minecraft.black_candle": "Lilin hitam",
  "block.minecraft.black_candle_cake": "Tar dengan lilin hitam",
  "block.minecraft.black_carpet": "Ambal hitam",
  "block.minecraft.black_concrete": "Beton hitam",
  "block.minecraft.black_concrete_powder": "Semen hitam",
  "block.minecraft.black_glazed_terracotta": "Tembikar hitam",
  "block.minecraft.black_shulker_box": "Kotak shulker hitam",
  "block.minecraft.black_stained_glass": "Katja hitam",
  "block.minecraft.black_stained_glass_pane": "Panel katja hitam",
  "block.minecraft.black_terracotta": "Térakota hitam",
  "block.minecraft.black_wool": "Wol hitam",
  "block.minecraft.blackstone": "Batoe hitam",
  "block.minecraft.blackstone_slab": "Pelat batoe hitam",
  "block.minecraft.blackstone_stairs": "Tangga batoe hitam",
  "block.minecraft.blackstone_wall": "Tembok batoe hitam",
  "block.minecraft.blast_furnace": "Tanoer tioep",
  "block.minecraft.blue_banner": "Pandji biroe",
  "block.minecraft.blue_bed": "Katil biroe",
  "block.minecraft.blue_candle": "Lilin biroe",
  "block.minecraft.blue_candle_cake": "Tar dengan lilin biroe",
  "block.minecraft.blue_carpet": "Ambal biroe",
  "block.minecraft.blue_concrete": "Beton biroe",
  "block.minecraft.blue_concrete_powder": "Semen biroe",
  "block.minecraft.blue_glazed_terracotta": "Tembikar biroe",
  "block.minecraft.blue_ice": "IJs biroe",
  "block.minecraft.blue_orchid": "Anggrek biroe",
  "block.minecraft.blue_shulker_box": "Kotak shulker biroe",
  "block.minecraft.blue_stained_glass": "Katja biroe",
  "block.minecraft.blue_stained_glass_pane": "Panel katja biroe",
  "block.minecraft.blue_terracotta": "Térakota biroe",
  "block.minecraft.blue_wool": "Wol biroe",
  "block.minecraft.bone_block": "Balok toelang",
  "block.minecraft.bookshelf": "Rak boekoe",
  "block.minecraft.brain_coral": "Karang otak",
  "block.minecraft.brain_coral_block": "Balok karang otak",
  "block.minecraft.brain_coral_fan": "Kipas laoet otak",
  "block.minecraft.brain_coral_wall_fan": "Kipas laoet otak dinding",
  "block.minecraft.brewing_stand": "Standar peramoean",
  "block.minecraft.brick_slab": "Pelat bata",
  "block.minecraft.brick_stairs": "Tangga bata",
  "block.minecraft.brick_wall": "Tembok bata",
  "block.minecraft.bricks": "Balok bata",
  "block.minecraft.brown_banner": "Pandji sawo matang",
  "block.minecraft.brown_bed": "Katil sawo matang",
  "block.minecraft.brown_candle": "Lilin sawo matang",
  "block.minecraft.brown_candle_cake": "Tar dengan lilin sawo matang",
  "block.minecraft.brown_carpet": "Ambal sawo matang",
  "block.minecraft.brown_concrete": "Beton sawo matang",
  "block.minecraft.brown_concrete_powder": "Semen sawo matang",
  "block.minecraft.brown_glazed_terracotta": "Tembikar sawo matang",
  "block.minecraft.brown_mushroom": "Djamoer sawo matang",
  "block.minecraft.brown_mushroom_block": "Balok djamoer sawo matang",
  "block.minecraft.brown_shulker_box": "Kotak shulker sawo matang",
  "block.minecraft.brown_stained_glass": "Katja sawo matang",
  "block.minecraft.brown_stained_glass_pane": "Panel katja sawo matang",
  "block.minecraft.brown_terracotta": "Térakota sawo matang",
  "block.minecraft.brown_wool": "Wol sawo matang",
  "block.minecraft.bubble_column": "Ladjoer gelemboeng",
  "block.minecraft.bubble_coral": "Karang gelemboeng",
  "block.minecraft.bubble_coral_block": "Balok karang gelemboeng",
  "block.minecraft.bubble_coral_fan": "Kipas laoet gelemboeng",
  "block.minecraft.bubble_coral_wall_fan": "Kipas laoet gelemboeng dinding",
  "block.minecraft.budding_amethyst": "Ketjoeboeng berkoentjoep",
  "block.minecraft.bush": "Semak",
  "block.minecraft.cactus": "Kaktoes",
  "block.minecraft.cactus_flower": "Boenga kaktoes",
  "block.minecraft.cake": "Tar",
  "block.minecraft.calcite": "Kalsit",
  "block.minecraft.calibrated_sculk_sensor": "Pengindra sculk terkalibrasi",
  "block.minecraft.campfire": "Api oenggoen",
  "block.minecraft.candle": "Lliin",
  "block.minecraft.candle_cake": "Tar dengan lilin",
  "block.minecraft.carrots": "Wortel",
  "block.minecraft.cartography_table": "Medja kartografi",
  "block.minecraft.carved_pumpkin": "Laboe teroekir",
  "block.minecraft.cauldron": "Koeali",
  "block.minecraft.cave_air": "Oedara goea",
  "block.minecraft.cave_vines": "Perambat goea",
  "block.minecraft.cave_vines_plant": "Tanaman perambat goea",
  "block.minecraft.chain": "Rantai",
  "block.minecraft.chain_command_block": "Balok perintah berantai",
  "block.minecraft.cherry_button": "Kenop kersen",
  "block.minecraft.cherry_door": "Pintoe kersen",
  "block.minecraft.cherry_fence": "Pagar kersen",
  "block.minecraft.cherry_fence_gate": "Pintoe pagar kersen",
  "block.minecraft.cherry_hanging_sign": "Papan tanda gantoeng kersen",
  "block.minecraft.cherry_leaves": "Daoen kersen",
  "block.minecraft.cherry_log": "Gelondong kersen",
  "block.minecraft.cherry_planks": "Papan kersen",
  "block.minecraft.cherry_pressure_plate": "Pelat penekan kersen",
  "block.minecraft.cherry_sapling": "Bibit kersen",
  "block.minecraft.cherry_shelf": "Rak kersen",
  "block.minecraft.cherry_sign": "Papan tanda kersen",
  "block.minecraft.cherry_slab": "Pelat kersen",
  "block.minecraft.cherry_stairs": "Tangga kersen",
  "block.minecraft.cherry_trapdoor": "Pintoe kolong kersen",
  "block.minecraft.cherry_wall_hanging_sign": "Papan tanda gantoeng dinding kersen",
  "block.minecraft.cherry_wall_sign": "Papan tanda dinding kersen",
  "block.minecraft.cherry_wood": "Kajoe kersen",
  "block.minecraft.chest": "Peti",
  "block.minecraft.chipped_anvil": "Paron tjoeil",
  "block.minecraft.chiseled_bookshelf": "Rak boekoe pahatan",
  "block.minecraft.chiseled_copper": "Tembaga pahatan",
  "block.minecraft.chiseled_deepslate": "Batoe gelita pahatan",
  "block.minecraft.chiseled_nether_bricks": "Bata nether pahatan",
  "block.minecraft.chiseled_polished_blackstone": "Batoe hitam gilap pahatan",
  "block.minecraft.chiseled_quartz_block": "Balok kwars pahatan",
  "block.minecraft.chiseled_red_sandstone": "Batoe pasir merah pahatan",
  "block.minecraft.chiseled_resin_bricks": "Bata damar pahatan",
  "block.minecraft.chiseled_sandstone": "Batoe pasir pahatan",
  "block.minecraft.chiseled_stone_bricks": "Bata batoe pahatan",
  "block.minecraft.chiseled_tuff": "Batoe aboe pahatan",
  "block.minecraft.chiseled_tuff_bricks": "Bata batoe aboe pahatan",
  "block.minecraft.chorus_flower": "Boenga koor",
  "block.minecraft.chorus_plant": "Pohon koor",
  "block.minecraft.clay": "Tanah liat",
  "block.minecraft.closed_eyeblossom": "Boenga mata pedjam",
  "block.minecraft.coal_block": "Balok batoe bara",
  "block.minecraft.coal_ore": "Bidjih batoe bara",
  "block.minecraft.coarse_dirt": "Tanah kasar",
  "block.minecraft.cobbled_deepslate": "Berangkal gelita",
  "block.minecraft.cobbled_deepslate_slab": "Pelat berangkal gelita",
  "block.minecraft.cobbled_deepslate_stairs": "Tangga berangkal gelita",
  "block.minecraft.cobbled_deepslate_wall": "Tembok berangkal gelita",
  "block.minecraft.cobblestone": "Berangkal",
  "block.minecraft.cobblestone_slab": "Pelat berangkal",
  "block.minecraft.cobblestone_stairs": "Tangga berangkal",
  "block.minecraft.cobblestone_wall": "Tembok berangkal",
  "block.minecraft.cobweb": "Djaring laba-laba",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Balok perintah",
  "block.minecraft.comparator": "Pembanding redstone",
  "block.minecraft.composter": "Bak kompos",
  "block.minecraft.conduit": "Talang",
  "block.minecraft.copper_bars": "Terali tembaga",
  "block.minecraft.copper_block": "Balok tembaga",
  "block.minecraft.copper_bulb": "Bohlam tembaga",
  "block.minecraft.copper_chain": "Rantai tembaga",
  "block.minecraft.copper_chest": "Peti tembaga",
  "block.minecraft.copper_door": "Pintoe tembaga",
  "block.minecraft.copper_golem_statue": "Patoeng golem tembaga",
  "block.minecraft.copper_grate": "Kisi-kisi tembaga",
  "block.minecraft.copper_lantern": "Lentera tembaga",
  "block.minecraft.copper_ore": "Bidjih tembaga",
  "block.minecraft.copper_torch": "Obor tembaga",
  "block.minecraft.copper_trapdoor": "Pintoe kolong tembaga",
  "block.minecraft.copper_wall_torch": "Obor dinding tembaga",
  "block.minecraft.cornflower": "Korenbloem",
  "block.minecraft.cracked_deepslate_bricks": "Bata batoe gelita retak",
  "block.minecraft.cracked_deepslate_tiles": "Tegel batoe gelita retak",
  "block.minecraft.cracked_nether_bricks": "Bata nether retak",
  "block.minecraft.cracked_polished_blackstone_bricks": "Bata batoe hitam gilap retak",
  "block.minecraft.cracked_stone_bricks": "Bata batoe retak",
  "block.minecraft.crafter": "Mesin keradjinan",
  "block.minecraft.crafting_table": "Medja keradjinan",
  "block.minecraft.creaking_heart": "Djantoeng kerioet",
  "block.minecraft.creeper_head": "Kepala creeper",
  "block.minecraft.creeper_wall_head": "Kepala dinding creeper",
  "block.minecraft.crimson_button": "Kenop kirmizi",
  "block.minecraft.crimson_door": "Pintoe kirmizi",
  "block.minecraft.crimson_fence": "Pagar kirmizi",
  "block.minecraft.crimson_fence_gate": "Pintoe pagar kirmizi",
  "block.minecraft.crimson_fungus": "Djamoer kirmizi",
  "block.minecraft.crimson_hanging_sign": "Papan tanda gantoeng kirmizi",
  "block.minecraft.crimson_hyphae": "Benang koelat kirmizi",
  "block.minecraft.crimson_nylium": "Djenaring kirmizi",
  "block.minecraft.crimson_planks": "Papan kirmizi",
  "block.minecraft.crimson_pressure_plate": "Pelat penekan kirmizi",
  "block.minecraft.crimson_roots": "Akar kirmizi",
  "block.minecraft.crimson_shelf": "Rak kirmizi",
  "block.minecraft.crimson_sign": "Papan tanda kirmizi",
  "block.minecraft.crimson_slab": "Pelat kirmizi",
  "block.minecraft.crimson_stairs": "Tangga kirmizi",
  "block.minecraft.crimson_stem": "Batang kirmizi",
  "block.minecraft.crimson_trapdoor": "Pintoe kolong kirmizi",
  "block.minecraft.crimson_wall_hanging_sign": "Papan tanda gantoeng dinding kirmizi",
  "block.minecraft.crimson_wall_sign": "Papan tanda dinding kirmizi",
  "block.minecraft.crying_obsidian": "Batoe gelas menangis",
  "block.minecraft.cut_copper": "Tembaga potongan",
  "block.minecraft.cut_copper_slab": "Pelat tembaga potongan",
  "block.minecraft.cut_copper_stairs": "Tangga tembaga potongan",
  "block.minecraft.cut_red_sandstone": "Batoe pasir merah potongan",
  "block.minecraft.cut_red_sandstone_slab": "Pelat batoe pasir merah potongan",
  "block.minecraft.cut_sandstone": "Batoe pasir potongan",
  "block.minecraft.cut_sandstone_slab": "Pelat batoe pasir potongan",
  "block.minecraft.cyan_banner": "Pandji nilangsoeka",
  "block.minecraft.cyan_bed": "Katil nilangsoeka",
  "block.minecraft.cyan_candle": "Lilin nilangsoeka",
  "block.minecraft.cyan_candle_cake": "Tar dengan lilin nilangsoeka",
  "block.minecraft.cyan_carpet": "Ambal nilangsoeka",
  "block.minecraft.cyan_concrete": "Beton nilangsoeka",
  "block.minecraft.cyan_concrete_powder": "Semen nilangsoeka",
  "block.minecraft.cyan_glazed_terracotta": "Tembikar nilangsoeka",
  "block.minecraft.cyan_shulker_box": "Kotak shulker nilangsoeka",
  "block.minecraft.cyan_stained_glass": "Katja nilangsoeka",
  "block.minecraft.cyan_stained_glass_pane": "Panel katja nilangsoeka",
  "block.minecraft.cyan_terracotta": "Térakota nilangsoeka",
  "block.minecraft.cyan_wool": "Wol nilangsoeka",
  "block.minecraft.damaged_anvil": "Paron roesak",
  "block.minecraft.dandelion": "Randa tapak",
  "block.minecraft.dark_oak_button": "Kenop eik gelap",
  "block.minecraft.dark_oak_door": "Pintoe eik gelap",
  "block.minecraft.dark_oak_fence": "Pagar eik gelap",
  "block.minecraft.dark_oak_fence_gate": "Pintoe pagar eik gelap",
  "block.minecraft.dark_oak_hanging_sign": "Papan tanda gantoeng eik gelap",
  "block.minecraft.dark_oak_leaves": "Daoen eik gelap",
  "block.minecraft.dark_oak_log": "Gelondong eik gelap",
  "block.minecraft.dark_oak_planks": "Papan eik gelap",
  "block.minecraft.dark_oak_pressure_plate": "Pelat penekan eik gelap",
  "block.minecraft.dark_oak_sapling": "Bibit eik gelap",
  "block.minecraft.dark_oak_shelf": "Rak eik gelap",
  "block.minecraft.dark_oak_sign": "Papan tanda eik gelap",
  "block.minecraft.dark_oak_slab": "Pelat eik gelap",
  "block.minecraft.dark_oak_stairs": "Tangga eik gelap",
  "block.minecraft.dark_oak_trapdoor": "Pintoe kolong eik gelap",
  "block.minecraft.dark_oak_wall_hanging_sign": "Papan tanda gantoeng dinding eik gelap",
  "block.minecraft.dark_oak_wall_sign": "Papan tanda dinding eik gelap",
  "block.minecraft.dark_oak_wood": "Kajoe eik gelap",
  "block.minecraft.dark_prismarine": "Prismarien gelap",
  "block.minecraft.dark_prismarine_slab": "Pelat prismarien gelap",
  "block.minecraft.dark_prismarine_stairs": "Tangga prismarien gelap",
  "block.minecraft.daylight_detector": "Pengindra tjahaja",
  "block.minecraft.dead_brain_coral": "Karang otak mati",
  "block.minecraft.dead_brain_coral_block": "Balok karang otak mati",
  "block.minecraft.dead_brain_coral_fan": "Kipas laoet otak mati",
  "block.minecraft.dead_brain_coral_wall_fan": "Kipas laoet otak dinding mati",
  "block.minecraft.dead_bubble_coral": "Karang gelemboeng mati",
  "block.minecraft.dead_bubble_coral_block": "Balok karang gelemboeng mati",
  "block.minecraft.dead_bubble_coral_fan": "Kipas laoet gelemboeng mati",
  "block.minecraft.dead_bubble_coral_wall_fan": "Kipas laoet gelemboeng dinding mati",
  "block.minecraft.dead_bush": "Semak mati",
  "block.minecraft.dead_fire_coral": "Karang api mati",
  "block.minecraft.dead_fire_coral_block": "Balok karang api mati",
  "block.minecraft.dead_fire_coral_fan": "Kipas laoet api mati",
  "block.minecraft.dead_fire_coral_wall_fan": "Kipas laoet api dinding mati",
  "block.minecraft.dead_horn_coral": "Karang tandoek mati",
  "block.minecraft.dead_horn_coral_block": "Balok karang tandoek mati",
  "block.minecraft.dead_horn_coral_fan": "Kipas laoet tandoek mati",
  "block.minecraft.dead_horn_coral_wall_fan": "Kipas laoet tandoek dinding mati",
  "block.minecraft.dead_tube_coral": "Karang pipa mati",
  "block.minecraft.dead_tube_coral_block": "Balok karang pipa mati",
  "block.minecraft.dead_tube_coral_fan": "Kipas laoet pipa mati",
  "block.minecraft.dead_tube_coral_wall_fan": "Kipas laoet pipa dinding mati",
  "block.minecraft.decorated_pot": "Pasoe",
  "block.minecraft.deepslate": "Batoe gelita",
  "block.minecraft.deepslate_brick_slab": "Pelat bata batoe gelita",
  "block.minecraft.deepslate_brick_stairs": "Tangga bata batoe gelita",
  "block.minecraft.deepslate_brick_wall": "Tembok bata batoe gelita",
  "block.minecraft.deepslate_bricks": "Bata batoe gelita",
  "block.minecraft.deepslate_coal_ore": "Bidjih batoe bara gelita",
  "block.minecraft.deepslate_copper_ore": "Bidjih tembaga gelita",
  "block.minecraft.deepslate_diamond_ore": "Bidjih berlian gelita",
  "block.minecraft.deepslate_emerald_ore": "Bidjih zamroed gelita",
  "block.minecraft.deepslate_gold_ore": "Bidjih emas gelita",
  "block.minecraft.deepslate_iron_ore": "Bidjih besi gelita",
  "block.minecraft.deepslate_lapis_ore": "Bidjih lazoewardi gelita",
  "block.minecraft.deepslate_redstone_ore": "Bidjih redstone gelita",
  "block.minecraft.deepslate_tile_slab": "Pelat tegel batoe gelita",
  "block.minecraft.deepslate_tile_stairs": "Tangga tegel batoe gelita",
  "block.minecraft.deepslate_tile_wall": "Tembok tegel batoe gelita",
  "block.minecraft.deepslate_tiles": "Tegel batoe gelita",
  "block.minecraft.detector_rail": "Spoor pengindra",
  "block.minecraft.diamond_block": "Balok berlian",
  "block.minecraft.diamond_ore": "Bidjih berlian",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Pelat diorit",
  "block.minecraft.diorite_stairs": "Tangga diorit",
  "block.minecraft.diorite_wall": "Tembok diorit",
  "block.minecraft.dirt": "Tanah",
  "block.minecraft.dirt_path": "Rintis tanah",
  "block.minecraft.dispenser": "Pelempar",
  "block.minecraft.dragon_egg": "Teloer Naga",
  "block.minecraft.dragon_head": "Kepala Naga",
  "block.minecraft.dragon_wall_head": "Kepala dinding Naga",
  "block.minecraft.dried_ghast": "Ghast kering",
  "block.minecraft.dried_kelp_block": "Balok komboe kering",
  "block.minecraft.dripstone_block": "Balok batoe tetes",
  "block.minecraft.dropper": "Pendjatoeh",
  "block.minecraft.emerald_block": "Balok zamroed",
  "block.minecraft.emerald_ore": "Bidjih zamroed",
  "block.minecraft.enchanting_table": "Medja pesona",
  "block.minecraft.end_gateway": "Gapoera End",
  "block.minecraft.end_portal": "Gerbang End",
  "block.minecraft.end_portal_frame": "Bingkai gerbang End",
  "block.minecraft.end_rod": "Tongkat End",
  "block.minecraft.end_stone": "Batoe End",
  "block.minecraft.end_stone_brick_slab": "Pelat bata batoe End",
  "block.minecraft.end_stone_brick_stairs": "Tangga bata batoe End",
  "block.minecraft.end_stone_brick_wall": "Tembok bata batoe End",
  "block.minecraft.end_stone_bricks": "Bata batoe End",
  "block.minecraft.ender_chest": "Peti Ender",
  "block.minecraft.exposed_chiseled_copper": "Tembaga pahatan terbeber",
  "block.minecraft.exposed_copper": "Tembaga terbeber",
  "block.minecraft.exposed_copper_bars": "Terali tembaga terbeber",
  "block.minecraft.exposed_copper_bulb": "Bohlam tembaga terbeber",
  "block.minecraft.exposed_copper_chain": "Rantai tembaga terbeber",
  "block.minecraft.exposed_copper_chest": "Peti tembaga terbeber",
  "block.minecraft.exposed_copper_door": "Pintoe tembaga terbeber",
  "block.minecraft.exposed_copper_golem_statue": "Patoeng golem tembaga terbeber",
  "block.minecraft.exposed_copper_grate": "Kisi-kisi tembaga terbeber",
  "block.minecraft.exposed_copper_lantern": "Lentera tembaga terbeber",
  "block.minecraft.exposed_copper_trapdoor": "Pintoe kolong tembaga terbeber",
  "block.minecraft.exposed_cut_copper": "Tembaga potongan terbeber",
  "block.minecraft.exposed_cut_copper_slab": "Pelat tembaga potongan terbeber",
  "block.minecraft.exposed_cut_copper_stairs": "Tangga tembaga potongan terbeber",
  "block.minecraft.exposed_lightning_rod": "Penangkal petir terbeber",
  "block.minecraft.farmland": "Tanah garapan",
  "block.minecraft.fern": "Pakis",
  "block.minecraft.fire": "Api",
  "block.minecraft.fire_coral": "Karang api",
  "block.minecraft.fire_coral_block": "Balok karang api",
  "block.minecraft.fire_coral_fan": "Kipas laoet api",
  "block.minecraft.fire_coral_wall_fan": "Kipas laoet api dinding",
  "block.minecraft.firefly_bush": "Semak koenang-koenang",
  "block.minecraft.fletching_table": "Medja pemboeatan panah",
  "block.minecraft.flower_pot": "Pot boenga",
  "block.minecraft.flowering_azalea": "Kadoedampit mekar",
  "block.minecraft.flowering_azalea_leaves": "Daoen kadoedampit mekar",
  "block.minecraft.frogspawn": "Teloer katak",
  "block.minecraft.frosted_ice": "IJs boeram",
  "block.minecraft.furnace": "Oven",
  "block.minecraft.gilded_blackstone": "Batoe hitam bersepoeh",
  "block.minecraft.glass": "Katja",
  "block.minecraft.glass_pane": "Panel katja",
  "block.minecraft.glow_lichen": "Loemoet kerak sinar",
  "block.minecraft.glowstone": "Batoe sinar",
  "block.minecraft.gold_block": "Balok emas",
  "block.minecraft.gold_ore": "Bidjih emas",
  "block.minecraft.golden_dandelion": "Randa tapak emas",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Pelat granit",
  "block.minecraft.granite_stairs": "Tangga granit",
  "block.minecraft.granite_wall": "Tembok granit",
  "block.minecraft.grass": "Roempoet",
  "block.minecraft.grass_block": "Balok roempoet",
  "block.minecraft.gravel": "Kerikil",
  "block.minecraft.gray_banner": "Pandji kelaboe",
  "block.minecraft.gray_bed": "Katil kelaboe",
  "block.minecraft.gray_candle": "Lilin kelaboe",
  "block.minecraft.gray_candle_cake": "Tar dengan lilin kelaboe",
  "block.minecraft.gray_carpet": "Ambal kelaboe",
  "block.minecraft.gray_concrete": "Beton kelaboe",
  "block.minecraft.gray_concrete_powder": "Semen kelaboe",
  "block.minecraft.gray_glazed_terracotta": "Tembikar kelaboe",
  "block.minecraft.gray_shulker_box": "Kotak shulker kelaboe",
  "block.minecraft.gray_stained_glass": "Katja kelaboe",
  "block.minecraft.gray_stained_glass_pane": "Panel katja kelaboe",
  "block.minecraft.gray_terracotta": "Térakota kelaboe",
  "block.minecraft.gray_wool": "Wol kelaboe",
  "block.minecraft.green_banner": "Pandji hidjau",
  "block.minecraft.green_bed": "Katil hidjau",
  "block.minecraft.green_candle": "Lilin hidjau",
  "block.minecraft.green_candle_cake": "Tar dengan lilin hidjau",
  "block.minecraft.green_carpet": "Ambal hidjau",
  "block.minecraft.green_concrete": "Beton hidjau",
  "block.minecraft.green_concrete_powder": "Semen hidjau",
  "block.minecraft.green_glazed_terracotta": "Tembikar hidjau",
  "block.minecraft.green_shulker_box": "Kotak shulker hidjau",
  "block.minecraft.green_stained_glass": "Katja hidjau",
  "block.minecraft.green_stained_glass_pane": "Panel katja hidjau",
  "block.minecraft.green_terracotta": "Térakota hidjau",
  "block.minecraft.green_wool": "Wol hidjau",
  "block.minecraft.grindstone": "Tjanai",
  "block.minecraft.hanging_roots": "Akar gantoeng",
  "block.minecraft.hay_block": "Djerami",
  "block.minecraft.heavy_core": "Kern berat",
  "block.minecraft.heavy_weighted_pressure_plate": "Pelat penekan berat",
  "block.minecraft.honey_block": "Balok madoe",
  "block.minecraft.honeycomb_block": "Balok sarang madoe",
  "block.minecraft.hopper": "Tjorong",
  "block.minecraft.horn_coral": "Karang tandoek",
  "block.minecraft.horn_coral_block": "Balok karang tandoek",
  "block.minecraft.horn_coral_fan": "Kipas laoet tandoek",
  "block.minecraft.horn_coral_wall_fan": "Kipas laoet tandoek dinding",
  "block.minecraft.ice": "IJs",
  "block.minecraft.infested_chiseled_stone_bricks": "Bata batoe pahatan berhama",
  "block.minecraft.infested_cobblestone": "Berangkal berhama",
  "block.minecraft.infested_cracked_stone_bricks": "Bata batoe retak berhama",
  "block.minecraft.infested_deepslate": "Batoe gelita berhama",
  "block.minecraft.infested_mossy_stone_bricks": "Bata batoe berloemoet berhama",
  "block.minecraft.infested_stone": "Batoe berhama",
  "block.minecraft.infested_stone_bricks": "Bata batoe berhama",
  "block.minecraft.iron_bars": "Terali besi",
  "block.minecraft.iron_block": "Balok besi",
  "block.minecraft.iron_chain": "Rantai besi",
  "block.minecraft.iron_door": "Pintoe besi",
  "block.minecraft.iron_ore": "Bidjih besi",
  "block.minecraft.iron_trapdoor": "Pintoe kolong besi",
  "block.minecraft.jack_o_lantern": "Lentera laboe",
  "block.minecraft.jigsaw": "Balok keping",
  "block.minecraft.jukebox": "Pemoetar pelat",
  "block.minecraft.jungle_button": "Kenop rimba",
  "block.minecraft.jungle_door": "Pintoe rimba",
  "block.minecraft.jungle_fence": "Pagar rimba",
  "block.minecraft.jungle_fence_gate": "Pintoe pagar rimba",
  "block.minecraft.jungle_hanging_sign": "Papan tanda gantoeng rimba",
  "block.minecraft.jungle_leaves": "Daoen rimba",
  "block.minecraft.jungle_log": "Gelondong rimba",
  "block.minecraft.jungle_planks": "Papan rimba",
  "block.minecraft.jungle_pressure_plate": "Pelat penekan rimba",
  "block.minecraft.jungle_sapling": "Bibit pohon rimba",
  "block.minecraft.jungle_shelf": "Rak rimba",
  "block.minecraft.jungle_sign": "Papan tanda rimba",
  "block.minecraft.jungle_slab": "Pelat rimba",
  "block.minecraft.jungle_stairs": "Tangga rimba",
  "block.minecraft.jungle_trapdoor": "Pintoe kolong rimba",
  "block.minecraft.jungle_wall_hanging_sign": "Papan tanda gantoeng dinding rimba",
  "block.minecraft.jungle_wall_sign": "Papan tanda dinding rimba",
  "block.minecraft.jungle_wood": "Kajoe rimba",
  "block.minecraft.kelp": "Komboe",
  "block.minecraft.kelp_plant": "Tanaman komboe",
  "block.minecraft.ladder": "Tangga",
  "block.minecraft.lantern": "Lentera",
  "block.minecraft.lapis_block": "Balok lazoewardi",
  "block.minecraft.lapis_ore": "Bidjih lazoewardi",
  "block.minecraft.large_amethyst_bud": "Koentjoep ketjoeboeng besar",
  "block.minecraft.large_fern": "Pakis besar",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Koeali lava",
  "block.minecraft.leaf_litter": "Daoen kering",
  "block.minecraft.lectern": "Lesnar",
  "block.minecraft.lever": "Toeas",
  "block.minecraft.light": "Tjahaja",
  "block.minecraft.light_blue_banner": "Pandji biroe moeda",
  "block.minecraft.light_blue_bed": "Katil biroe moeda",
  "block.minecraft.light_blue_candle": "Lilin biroe moeda",
  "block.minecraft.light_blue_candle_cake": "Tar dengan lilin biroe moeda",
  "block.minecraft.light_blue_carpet": "Ambal biroe moeda",
  "block.minecraft.light_blue_concrete": "Beton biroe moeda",
  "block.minecraft.light_blue_concrete_powder": "Semen biroe moeda",
  "block.minecraft.light_blue_glazed_terracotta": "Tembikar biroe moeda",
  "block.minecraft.light_blue_shulker_box": "Kotak shulker biroe moeda",
  "block.minecraft.light_blue_stained_glass": "Katja biroe moeda",
  "block.minecraft.light_blue_stained_glass_pane": "Panel katja biroe moeda",
  "block.minecraft.light_blue_terracotta": "Térakota biroe moeda",
  "block.minecraft.light_blue_wool": "Wol biroe moeda",
  "block.minecraft.light_gray_banner": "Pandji kelaboe moeda",
  "block.minecraft.light_gray_bed": "Katil kelaboe moeda",
  "block.minecraft.light_gray_candle": "Lilin kelaboe moeda",
  "block.minecraft.light_gray_candle_cake": "Tar dengan lilin kelaboe moeda",
  "block.minecraft.light_gray_carpet": "Ambal kelaboe moeda",
  "block.minecraft.light_gray_concrete": "Beton kelaboe moeda",
  "block.minecraft.light_gray_concrete_powder": "Semen kelaboe moeda",
  "block.minecraft.light_gray_glazed_terracotta": "Tembikar kelaboe moeda",
  "block.minecraft.light_gray_shulker_box": "Kotak shulker kelaboe moeda",
  "block.minecraft.light_gray_stained_glass": "Katja kelaboe moeda",
  "block.minecraft.light_gray_stained_glass_pane": "Panel katja kelaboe moeda",
  "block.minecraft.light_gray_terracotta": "Térakota kelaboe moeda",
  "block.minecraft.light_gray_wool": "Wol kelaboe moeda",
  "block.minecraft.light_weighted_pressure_plate": "Pelat penekan ringan",
  "block.minecraft.lightning_rod": "Penangkal petir",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Leli lembah",
  "block.minecraft.lily_pad": "Daoen leli aïr",
  "block.minecraft.lime_banner": "Pandji hidjau poepoes",
  "block.minecraft.lime_bed": "Katil hidjau poepoes",
  "block.minecraft.lime_candle": "Lilin hidjau poepoes",
  "block.minecraft.lime_candle_cake": "Tar dengan lilin hidjau poepoes",
  "block.minecraft.lime_carpet": "Ambal hidjau poepoes",
  "block.minecraft.lime_concrete": "Beton hidjau poepoes",
  "block.minecraft.lime_concrete_powder": "Semen hidjau poepoes",
  "block.minecraft.lime_glazed_terracotta": "Tembikar hidjau poepoes",
  "block.minecraft.lime_shulker_box": "Kotak shulker hidjau poepoes",
  "block.minecraft.lime_stained_glass": "Katja hidjau poepoes",
  "block.minecraft.lime_stained_glass_pane": "Panel katja hidjau poepoes",
  "block.minecraft.lime_terracotta": "Térakota hidjau poepoes",
  "block.minecraft.lime_wool": "Wol hidjau poepoes",
  "block.minecraft.lodestone": "Batoe magnet",
  "block.minecraft.loom": "Kik",
  "block.minecraft.magenta_banner": "Pandji patma",
  "block.minecraft.magenta_bed": "Katil patma",
  "block.minecraft.magenta_candle": "Lilin patma",
  "block.minecraft.magenta_candle_cake": "Tar dengan lilin patma",
  "block.minecraft.magenta_carpet": "Ambal patma",
  "block.minecraft.magenta_concrete": "Beton patma",
  "block.minecraft.magenta_concrete_powder": "Semen patma",
  "block.minecraft.magenta_glazed_terracotta": "Tembikar patma",
  "block.minecraft.magenta_shulker_box": "Kotak shulker patma",
  "block.minecraft.magenta_stained_glass": "Katja patma",
  "block.minecraft.magenta_stained_glass_pane": "Panel katja patma",
  "block.minecraft.magenta_terracotta": "Térakota patma",
  "block.minecraft.magenta_wool": "Wol patma",
  "block.minecraft.magma_block": "Balok magma",
  "block.minecraft.mangrove_button": "Kenop bakau",
  "block.minecraft.mangrove_door": "Pintoe bakau",
  "block.minecraft.mangrove_fence": "Pagar bakau",
  "block.minecraft.mangrove_fence_gate": "Pintoe pagar bakau",
  "block.minecraft.mangrove_hanging_sign": "Papan tanda gantoeng bakau",
  "block.minecraft.mangrove_leaves": "Daoen bakau",
  "block.minecraft.mangrove_log": "Gelondong bakau",
  "block.minecraft.mangrove_planks": "Papan bakau",
  "block.minecraft.mangrove_pressure_plate": "Pelat penekan bakau",
  "block.minecraft.mangrove_propagule": "Bibit bakau",
  "block.minecraft.mangrove_roots": "Akar bakau",
  "block.minecraft.mangrove_shelf": "Rak bakau",
  "block.minecraft.mangrove_sign": "Papan tanda bakau",
  "block.minecraft.mangrove_slab": "Pelat bakau",
  "block.minecraft.mangrove_stairs": "Tangga bakau",
  "block.minecraft.mangrove_trapdoor": "Pintoe kolong bakau",
  "block.minecraft.mangrove_wall_hanging_sign": "Papan tanda gantoeng dinding bakau",
  "block.minecraft.mangrove_wall_sign": "Papan tanda dinding bakau",
  "block.minecraft.mangrove_wood": "Kajoe bakau",
  "block.minecraft.medium_amethyst_bud": "Koentjoep ketjoeboeng menengah",
  "block.minecraft.melon": "Semangka",
  "block.minecraft.melon_stem": "Batang semangka",
  "block.minecraft.moss_block": "Balok loemoet",
  "block.minecraft.moss_carpet": "Hamparan loemoet",
  "block.minecraft.mossy_cobblestone": "Berangkal berloemoet",
  "block.minecraft.mossy_cobblestone_slab": "Pelat berangkal berloemoet",
  "block.minecraft.mossy_cobblestone_stairs": "Tangga berangkal berloemoet",
  "block.minecraft.mossy_cobblestone_wall": "Tembok berangkal berloemoet",
  "block.minecraft.mossy_stone_brick_slab": "Pelat bata batoe berloemoet",
  "block.minecraft.mossy_stone_brick_stairs": "Tangga bata batoe berloemoet",
  "block.minecraft.mossy_stone_brick_wall": "Tembok bata batoe berloemoet",
  "block.minecraft.mossy_stone_bricks": "Bata batoe berloemoet",
  "block.minecraft.moving_piston": "Piston bergerak",
  "block.minecraft.mud": "Loempoer",
  "block.minecraft.mud_brick_slab": "Pelat bata loempoer",
  "block.minecraft.mud_brick_stairs": "Tangga bata loempoer",
  "block.minecraft.mud_brick_wall": "Tembok bata loempoer",
  "block.minecraft.mud_bricks": "Bata loempoer",
  "block.minecraft.muddy_mangrove_roots": "Akar bakau berloempoer",
  "block.minecraft.mushroom_stem": "Batang djamoer",
  "block.minecraft.mycelium": "Djaring koelat",
  "block.minecraft.nether_brick_fence": "Pagar bata nether",
  "block.minecraft.nether_brick_slab": "Pelat bata nether",
  "block.minecraft.nether_brick_stairs": "Tangga bata nether",
  "block.minecraft.nether_brick_wall": "Tembok bata nether",
  "block.minecraft.nether_bricks": "Balok bata nether",
  "block.minecraft.nether_gold_ore": "Bidjih emas Nether",
  "block.minecraft.nether_portal": "Gerbang Nether",
  "block.minecraft.nether_quartz_ore": "Bidjih kwars nether",
  "block.minecraft.nether_sprouts": "Ketjambah Nether",
  "block.minecraft.nether_wart": "Ketoeat Nether",
  "block.minecraft.nether_wart_block": "Balok ketoeat Nether",
  "block.minecraft.netherite_block": "Balok netherit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Kotak nada",
  "block.minecraft.oak_button": "Kenop eik",
  "block.minecraft.oak_door": "Pintoe eik",
  "block.minecraft.oak_fence": "Pagar eik",
  "block.minecraft.oak_fence_gate": "Pintoe pagar eik",
  "block.minecraft.oak_hanging_sign": "Papan tanda gantoeng eik",
  "block.minecraft.oak_leaves": "Daoen eik",
  "block.minecraft.oak_log": "Gelondong eik",
  "block.minecraft.oak_planks": "Papan eik",
  "block.minecraft.oak_pressure_plate": "Pelat penekan eik",
  "block.minecraft.oak_sapling": "Bibit eik",
  "block.minecraft.oak_shelf": "Rak eik",
  "block.minecraft.oak_sign": "Papan tanda eik",
  "block.minecraft.oak_slab": "Pelat eik",
  "block.minecraft.oak_stairs": "Tangga eik",
  "block.minecraft.oak_trapdoor": "Pintoe kolong eik",
  "block.minecraft.oak_wall_hanging_sign": "Papan tanda gantoeng dinding eik",
  "block.minecraft.oak_wall_sign": "Papan tanda dinding eik",
  "block.minecraft.oak_wood": "Kajoe eik",
  "block.minecraft.observer": "Pengamat",
  "block.minecraft.obsidian": "Batoe gelas",
  "block.minecraft.ochre_froglight": "Lampoe katak hartal",
  "block.minecraft.ominous_banner": "Pandji seram",
  "block.minecraft.open_eyeblossom": "Boenga mata djaga",
  "block.minecraft.orange_banner": "Pandji oranje",
  "block.minecraft.orange_bed": "Katil oranje",
  "block.minecraft.orange_candle": "Lilin oranje",
  "block.minecraft.orange_candle_cake": "Tar dengan lilin oranje",
  "block.minecraft.orange_carpet": "Ambal oranje",
  "block.minecraft.orange_concrete": "Beton oranje",
  "block.minecraft.orange_concrete_powder": "Semen oranje",
  "block.minecraft.orange_glazed_terracotta": "Tembikar oranje",
  "block.minecraft.orange_shulker_box": "Kotak shulker oranje",
  "block.minecraft.orange_stained_glass": "Katja oranje",
  "block.minecraft.orange_stained_glass_pane": "Panel katja oranje",
  "block.minecraft.orange_terracotta": "Térakota oranje",
  "block.minecraft.orange_tulip": "Tulp oranje",
  "block.minecraft.orange_wool": "Wol oranje",
  "block.minecraft.oxeye_daisy": "Margriet",
  "block.minecraft.oxidized_chiseled_copper": "Tembaga pahatan teroksidir",
  "block.minecraft.oxidized_copper": "Tembaga teroksidir",
  "block.minecraft.oxidized_copper_bars": "Terali tembaga teroksidir",
  "block.minecraft.oxidized_copper_bulb": "Bohlam tembaga teroksidir",
  "block.minecraft.oxidized_copper_chain": "Rantai tembaga teroksidir",
  "block.minecraft.oxidized_copper_chest": "Peti tembaga teroksidir",
  "block.minecraft.oxidized_copper_door": "Pintoe tembaga teroksidir",
  "block.minecraft.oxidized_copper_golem_statue": "Patoeng golem tembaga teroksidir",
  "block.minecraft.oxidized_copper_grate": "Kisi-kisi tembaga teroksidir",
  "block.minecraft.oxidized_copper_lantern": "Lentera tembaga teroksidir",
  "block.minecraft.oxidized_copper_trapdoor": "Pintoe kolong tembaga teroksidir",
  "block.minecraft.oxidized_cut_copper": "Tembaga potongan teroksidir",
  "block.minecraft.oxidized_cut_copper_slab": "Pelat tembaga potongan teroksidir",
  "block.minecraft.oxidized_cut_copper_stairs": "Tangga tembaga potongan teroksidir",
  "block.minecraft.oxidized_lightning_rod": "Penangkal petir teroksidir",
  "block.minecraft.packed_ice": "IJs padat",
  "block.minecraft.packed_mud": "Loempoer padat",
  "block.minecraft.pale_hanging_moss": "Loemoet poetjat gantoeng",
  "block.minecraft.pale_moss_block": "Balok loemoet poetjat",
  "block.minecraft.pale_moss_carpet": "Hamparan loemoet poetjat",
  "block.minecraft.pale_oak_button": "Kenop eik poetjat",
  "block.minecraft.pale_oak_door": "Pintoe eik poetjat",
  "block.minecraft.pale_oak_fence": "Pagar eik poetjat",
  "block.minecraft.pale_oak_fence_gate": "Pintoe pagar eik poetjat",
  "block.minecraft.pale_oak_hanging_sign": "Papan tanda gantoeng eik poetjat",
  "block.minecraft.pale_oak_leaves": "Daoen eik poetjat",
  "block.minecraft.pale_oak_log": "Gelondong eik poetjat",
  "block.minecraft.pale_oak_planks": "Papan eik poetjat",
  "block.minecraft.pale_oak_pressure_plate": "Pelat penekan eik poetjat",
  "block.minecraft.pale_oak_sapling": "Bibit eik poetjat",
  "block.minecraft.pale_oak_shelf": "Rak eik poetjat",
  "block.minecraft.pale_oak_sign": "Papan tanda eik poetjat",
  "block.minecraft.pale_oak_slab": "Pelat eik poetjat",
  "block.minecraft.pale_oak_stairs": "Tangga eik poetjat",
  "block.minecraft.pale_oak_trapdoor": "Pintoe kolong eik poetjat",
  "block.minecraft.pale_oak_wall_hanging_sign": "Papan tanda gantoeng dinding eik poetjat",
  "block.minecraft.pale_oak_wall_sign": "Papan tanda gantoeng dinding",
  "block.minecraft.pale_oak_wood": "Kajoe eik poetjat",
  "block.minecraft.pearlescent_froglight": "Lampoe katak gemerlap",
  "block.minecraft.peony": "Moedan",
  "block.minecraft.petrified_oak_slab": "Pelat eik membatoe",
  "block.minecraft.piglin_head": "Kepala piglin",
  "block.minecraft.piglin_wall_head": "Kepala dinding piglin",
  "block.minecraft.pink_banner": "Pandji djambon",
  "block.minecraft.pink_bed": "Katil djambon",
  "block.minecraft.pink_candle": "Lilin djambon",
  "block.minecraft.pink_candle_cake": "Tar dengan lilin djambon",
  "block.minecraft.pink_carpet": "Ambal djambon",
  "block.minecraft.pink_concrete": "Beton djambon",
  "block.minecraft.pink_concrete_powder": "Semen djambon",
  "block.minecraft.pink_glazed_terracotta": "Tembikar djambon",
  "block.minecraft.pink_petals": "Mahkota djambon",
  "block.minecraft.pink_shulker_box": "Kotak shulker djambon",
  "block.minecraft.pink_stained_glass": "Katja djambon",
  "block.minecraft.pink_stained_glass_pane": "Panel katja djambon",
  "block.minecraft.pink_terracotta": "Térakota djambon",
  "block.minecraft.pink_tulip": "Tulp djambon",
  "block.minecraft.pink_wool": "Wol djambon",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Kepala piston",
  "block.minecraft.pitcher_crop": "Tanaman perioek kera",
  "block.minecraft.pitcher_plant": "Perioek kera",
  "block.minecraft.player_head": "Kepala pemaïn",
  "block.minecraft.player_head.named": "Kepala %s",
  "block.minecraft.player_wall_head": "Kepala dinding pemaïn",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Batoe tetes roentjing",
  "block.minecraft.polished_andesite": "Andesit gilap",
  "block.minecraft.polished_andesite_slab": "Pelat andesit gilap",
  "block.minecraft.polished_andesite_stairs": "Tangga andesit gilap",
  "block.minecraft.polished_basalt": "Basal gilap",
  "block.minecraft.polished_blackstone": "Batoe hitam gilap",
  "block.minecraft.polished_blackstone_brick_slab": "Pelat bata batoe hitam gilap",
  "block.minecraft.polished_blackstone_brick_stairs": "Tangga bata batoe hitam gilap",
  "block.minecraft.polished_blackstone_brick_wall": "Tembok bata batoe hitam gilap",
  "block.minecraft.polished_blackstone_bricks": "Bata batoe hitam gilap",
  "block.minecraft.polished_blackstone_button": "Kenop bata batoe hitam gilap",
  "block.minecraft.polished_blackstone_pressure_plate": "Pelat penekan batoe hitam gilap",
  "block.minecraft.polished_blackstone_slab": "Pelat batoe hitam gilap",
  "block.minecraft.polished_blackstone_stairs": "Tangga batoe hitam gilap",
  "block.minecraft.polished_blackstone_wall": "Tembok batoe hitam gilap",
  "block.minecraft.polished_deepslate": "Batoe gelita gilap",
  "block.minecraft.polished_deepslate_slab": "Pelat batoe gelita gilap",
  "block.minecraft.polished_deepslate_stairs": "Tangga batoe gelita gilap",
  "block.minecraft.polished_deepslate_wall": "Tembok batoe gelita gilap",
  "block.minecraft.polished_diorite": "Diorit gilap",
  "block.minecraft.polished_diorite_slab": "Pelat diorit gilap",
  "block.minecraft.polished_diorite_stairs": "Tangga diorit gilap",
  "block.minecraft.polished_granite": "Granit gilap",
  "block.minecraft.polished_granite_slab": "Pelat granit gilap",
  "block.minecraft.polished_granite_stairs": "Tangga granit gilap",
  "block.minecraft.polished_tuff": "Batoe aboe gilap",
  "block.minecraft.polished_tuff_slab": "Pelat batoe aboe gilap",
  "block.minecraft.polished_tuff_stairs": "Tangga batoe aboe gilap",
  "block.minecraft.polished_tuff_wall": "Tembok batoe aboe gilap",
  "block.minecraft.poppy": "Papaver",
  "block.minecraft.potatoes": "Kentang",
  "block.minecraft.potted_acacia_sapling": "Bibit pilang pot",
  "block.minecraft.potted_allium": "Boenga bawang pot",
  "block.minecraft.potted_azalea_bush": "Kadoedampit pot",
  "block.minecraft.potted_azure_bluet": "Boenga liar biroe pot",
  "block.minecraft.potted_bamboo": "Bamboe pot",
  "block.minecraft.potted_birch_sapling": "Bibit berk pot",
  "block.minecraft.potted_blue_orchid": "Anggrek biroe pot",
  "block.minecraft.potted_brown_mushroom": "Djamoer sawo matang pot",
  "block.minecraft.potted_cactus": "Kaktoes pot",
  "block.minecraft.potted_cherry_sapling": "Bibit kersen pot",
  "block.minecraft.potted_closed_eyeblossom": "Boenga mata pedjam pot",
  "block.minecraft.potted_cornflower": "Korenbloem pot",
  "block.minecraft.potted_crimson_fungus": "Djamoer kirmizi pot",
  "block.minecraft.potted_crimson_roots": "Akar kirmizi pot",
  "block.minecraft.potted_dandelion": "Randa tapak pot",
  "block.minecraft.potted_dark_oak_sapling": "Bibit eik gelap pot",
  "block.minecraft.potted_dead_bush": "Semak mati pot",
  "block.minecraft.potted_fern": "Pakis pot",
  "block.minecraft.potted_flowering_azalea_bush": "Kadoedampit mekar pot",
  "block.minecraft.potted_golden_dandelion": "Randa tapak emas pot",
  "block.minecraft.potted_jungle_sapling": "Bibit pohon rimba pot",
  "block.minecraft.potted_lily_of_the_valley": "Leli lembah pot",
  "block.minecraft.potted_mangrove_propagule": "Bibit bakau pot",
  "block.minecraft.potted_oak_sapling": "Bibit eik pot",
  "block.minecraft.potted_open_eyeblossom": "Boenga mata djaga pot",
  "block.minecraft.potted_orange_tulip": "Tulp oranje pot",
  "block.minecraft.potted_oxeye_daisy": "Margriet pot",
  "block.minecraft.potted_pale_oak_sapling": "Bibit eik poetjat pot",
  "block.minecraft.potted_pink_tulip": "Tulp djambon pot",
  "block.minecraft.potted_poppy": "Papaver pot",
  "block.minecraft.potted_red_mushroom": "Djamoer merah pot",
  "block.minecraft.potted_red_tulip": "Tulp merah pot",
  "block.minecraft.potted_spruce_sapling": "Bibit tjemara pot",
  "block.minecraft.potted_torchflower": "Boenga obor plot",
  "block.minecraft.potted_warped_fungus": "Djamoer keroekoet pot",
  "block.minecraft.potted_warped_roots": "Akar keroekoet pot",
  "block.minecraft.potted_white_tulip": "Tulp poetih pot",
  "block.minecraft.potted_wither_rose": "Mawar Wither pot",
  "block.minecraft.powder_snow": "Saldjoe poeder",
  "block.minecraft.powder_snow_cauldron": "Koeali saldjoe poeder",
  "block.minecraft.powered_rail": "Spoor berdaja",
  "block.minecraft.prismarine": "Prismarien",
  "block.minecraft.prismarine_brick_slab": "Pelat bata prismarien",
  "block.minecraft.prismarine_brick_stairs": "Tangga bata prismarien",
  "block.minecraft.prismarine_bricks": "Bata prismarien",
  "block.minecraft.prismarine_slab": "Pelat prismarien",
  "block.minecraft.prismarine_stairs": "Tangga prismarien",
  "block.minecraft.prismarine_wall": "Tembok prismarien",
  "block.minecraft.pumpkin": "Laboe",
  "block.minecraft.pumpkin_stem": "Batang laboe",
  "block.minecraft.purple_banner": "Pandji oengoe",
  "block.minecraft.purple_bed": "Katil oengoe",
  "block.minecraft.purple_candle": "Lilin oengoe",
  "block.minecraft.purple_candle_cake": "Tar dengan lilin oengoe",
  "block.minecraft.purple_carpet": "Ambal oengoe",
  "block.minecraft.purple_concrete": "Beton oengoe",
  "block.minecraft.purple_concrete_powder": "Semen oengoe",
  "block.minecraft.purple_glazed_terracotta": "Tembikar oengoe",
  "block.minecraft.purple_shulker_box": "Kotak shulker oengoe",
  "block.minecraft.purple_stained_glass": "Katja oengoe",
  "block.minecraft.purple_stained_glass_pane": "Panel katja oengoe",
  "block.minecraft.purple_terracotta": "Térakota oengoe",
  "block.minecraft.purple_wool": "Wol oengoe",
  "block.minecraft.purpur_block": "Balok purpur",
  "block.minecraft.purpur_pillar": "Pilar purpur",
  "block.minecraft.purpur_slab": "Pelat purpur",
  "block.minecraft.purpur_stairs": "Tangga purpur",
  "block.minecraft.quartz_block": "Balok kwars",
  "block.minecraft.quartz_bricks": "Bata kwars",
  "block.minecraft.quartz_pillar": "Pilar kwars",
  "block.minecraft.quartz_slab": "Pelat kwars",
  "block.minecraft.quartz_stairs": "Tangga kwars",
  "block.minecraft.rail": "Spoor",
  "block.minecraft.raw_copper_block": "Balok tembaga mentah",
  "block.minecraft.raw_gold_block": "Balok emas mentah",
  "block.minecraft.raw_iron_block": "Balok besi mentah",
  "block.minecraft.red_banner": "Pandji merah",
  "block.minecraft.red_bed": "Katil merah",
  "block.minecraft.red_candle": "Lilin merah",
  "block.minecraft.red_candle_cake": "Tar dengan lilin merah",
  "block.minecraft.red_carpet": "Ambal merah",
  "block.minecraft.red_concrete": "Beton merah",
  "block.minecraft.red_concrete_powder": "Semen merah",
  "block.minecraft.red_glazed_terracotta": "Tembikar merah",
  "block.minecraft.red_mushroom": "Djamoer merah",
  "block.minecraft.red_mushroom_block": "Balok djamoer merah",
  "block.minecraft.red_nether_brick_slab": "Pelat bata nether merah",
  "block.minecraft.red_nether_brick_stairs": "Tangga bata nether merah",
  "block.minecraft.red_nether_brick_wall": "Tembok bata nether merah",
  "block.minecraft.red_nether_bricks": "Bata nether merah",
  "block.minecraft.red_sand": "Pasir merah",
  "block.minecraft.red_sandstone": "Batoe pasir merah",
  "block.minecraft.red_sandstone_slab": "Pelat batoe pasir merah",
  "block.minecraft.red_sandstone_stairs": "Tangga batoe pasir merah",
  "block.minecraft.red_sandstone_wall": "Tembok batoe pasir merah",
  "block.minecraft.red_shulker_box": "Kotak shulker merah",
  "block.minecraft.red_stained_glass": "Katja merah",
  "block.minecraft.red_stained_glass_pane": "Panel katja merah",
  "block.minecraft.red_terracotta": "Térakota merah",
  "block.minecraft.red_tulip": "Tulp merah",
  "block.minecraft.red_wool": "Wol merah",
  "block.minecraft.redstone_block": "Balok redstone",
  "block.minecraft.redstone_lamp": "Lampoe redstone",
  "block.minecraft.redstone_ore": "Bidjih redstone",
  "block.minecraft.redstone_torch": "Obor redstone",
  "block.minecraft.redstone_wall_torch": "Obor dinding redstone",
  "block.minecraft.redstone_wire": "Kabel redstone",
  "block.minecraft.reinforced_deepslate": "Batoe gelita diperkokoh",
  "block.minecraft.repeater": "Pengoelang redstone",
  "block.minecraft.repeating_command_block": "Balok perintah mengoelang",
  "block.minecraft.resin_block": "Balok damar",
  "block.minecraft.resin_brick_slab": "Pelat bata damar",
  "block.minecraft.resin_brick_stairs": "Tangga bata damar",
  "block.minecraft.resin_brick_wall": "Tembok bata damar",
  "block.minecraft.resin_bricks": "Balok bata damar",
  "block.minecraft.resin_clump": "Goempalan damar",
  "block.minecraft.respawn_anchor": "Angker pembangkit",
  "block.minecraft.rooted_dirt": "Tanah berakar",
  "block.minecraft.rose_bush": "Semak mawar",
  "block.minecraft.sand": "Pasir",
  "block.minecraft.sandstone": "Batoe pasir",
  "block.minecraft.sandstone_slab": "Pelat batoe pasir",
  "block.minecraft.sandstone_stairs": "Tangga batoe pasir",
  "block.minecraft.sandstone_wall": "Tembok batoe pasir",
  "block.minecraft.scaffolding": "Perantjah",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Katalisator sculk",
  "block.minecraft.sculk_sensor": "Pengindra sculk",
  "block.minecraft.sculk_shrieker": "Sculk pendjerit",
  "block.minecraft.sculk_vein": "Oerat sculk",
  "block.minecraft.sea_lantern": "Lentera laoet",
  "block.minecraft.sea_pickle": "Atjar laoet",
  "block.minecraft.seagrass": "Latoeh",
  "block.minecraft.set_spawn": "Titik bangkit ditetapkan",
  "block.minecraft.short_dry_grass": "Roempoet kering pendek",
  "block.minecraft.short_grass": "Roempoet pendek",
  "block.minecraft.shroomlight": "Lampoe djamoer",
  "block.minecraft.shulker_box": "Kotak shulker",
  "block.minecraft.skeleton_skull": "Tengkorak bengkarak",
  "block.minecraft.skeleton_wall_skull": "Tengkorak dinding bengkarak",
  "block.minecraft.slime_block": "Balok geladir",
  "block.minecraft.small_amethyst_bud": "Koentjoep ketjoeboeng ketjil",
  "block.minecraft.small_dripleaf": "Daoen tetes ketjil",
  "block.minecraft.smithing_table": "Medja tempa",
  "block.minecraft.smoker": "Pengasap",
  "block.minecraft.smooth_basalt": "Basal haloes",
  "block.minecraft.smooth_quartz": "Balok kwars haloes",
  "block.minecraft.smooth_quartz_slab": "Pelat kwars haloes",
  "block.minecraft.smooth_quartz_stairs": "Tangga kwars haloes",
  "block.minecraft.smooth_red_sandstone": "Batoe pasir merah haloes",
  "block.minecraft.smooth_red_sandstone_slab": "Pelat batoe pasir merah haloes",
  "block.minecraft.smooth_red_sandstone_stairs": "Tangga batoe pasir merah haloes",
  "block.minecraft.smooth_sandstone": "Batoe pasir haloes",
  "block.minecraft.smooth_sandstone_slab": "Pelat batoe pasir haloes",
  "block.minecraft.smooth_sandstone_stairs": "Tangga batoe pasir haloes",
  "block.minecraft.smooth_stone": "Batoe haloes",
  "block.minecraft.smooth_stone_slab": "Pelat batoe haloes",
  "block.minecraft.sniffer_egg": "Teloer pengendoes",
  "block.minecraft.snow": "Saldjoe",
  "block.minecraft.snow_block": "Balok saldjoe",
  "block.minecraft.soul_campfire": "Api oenggoen djiwa",
  "block.minecraft.soul_fire": "Api djiwa",
  "block.minecraft.soul_lantern": "Lentera djiwa",
  "block.minecraft.soul_sand": "Pasir djiwa",
  "block.minecraft.soul_soil": "Tanah djiwa",
  "block.minecraft.soul_torch": "Obor djiwa",
  "block.minecraft.soul_wall_torch": "Obor dinding djiwa",
  "block.minecraft.spawn.not_valid": "Katil atau angker pembangkit toean tidak ada atau terhalang",
  "block.minecraft.spawner": "Pembangkit monster",
  "block.minecraft.spawner.desc1": "Interaksi dengan teloer pewoedjoedan:",
  "block.minecraft.spawner.desc2": "Menjetel djenis machloek",
  "block.minecraft.sponge": "Spons",
  "block.minecraft.spore_blossom": "Kembang spora",
  "block.minecraft.spruce_button": "Kenop tjemara",
  "block.minecraft.spruce_door": "Pintoe tjemara",
  "block.minecraft.spruce_fence": "Pagar tjemara",
  "block.minecraft.spruce_fence_gate": "Pintoe pagar tjemara",
  "block.minecraft.spruce_hanging_sign": "Papan tanda gantoeng tjemara",
  "block.minecraft.spruce_leaves": "Daoen tjemara",
  "block.minecraft.spruce_log": "Gelondong tjemara",
  "block.minecraft.spruce_planks": "Papan tjemara",
  "block.minecraft.spruce_pressure_plate": "Pelat penekan tjemara",
  "block.minecraft.spruce_sapling": "Bibit tjemara",
  "block.minecraft.spruce_shelf": "Rak tjemara",
  "block.minecraft.spruce_sign": "Papan tanda tjemara",
  "block.minecraft.spruce_slab": "Pelat tjemara",
  "block.minecraft.spruce_stairs": "Tangga tjemara",
  "block.minecraft.spruce_trapdoor": "Pintoe kolong tjemara",
  "block.minecraft.spruce_wall_hanging_sign": "Papan tanda gantoeng dinding tjemara",
  "block.minecraft.spruce_wall_sign": "Papan tanda dinding tjemara",
  "block.minecraft.spruce_wood": "Kajoe tjemara",
  "block.minecraft.sticky_piston": "Piston lengket",
  "block.minecraft.stone": "Batoe",
  "block.minecraft.stone_brick_slab": "Pelat bata batoe",
  "block.minecraft.stone_brick_stairs": "Tangga bata batoe",
  "block.minecraft.stone_brick_wall": "Tembok bata batoe",
  "block.minecraft.stone_bricks": "Bata batoe",
  "block.minecraft.stone_button": "Kenop batoe",
  "block.minecraft.stone_pressure_plate": "Pelat penekan batoe",
  "block.minecraft.stone_slab": "Pelat batoe",
  "block.minecraft.stone_stairs": "Tangga batoe",
  "block.minecraft.stonecutter": "Pemahat batoe",
  "block.minecraft.stripped_acacia_log": "Gelondong pilang koepas",
  "block.minecraft.stripped_acacia_wood": "Kajoe pilang koepas",
  "block.minecraft.stripped_bamboo_block": "Balok bamboe koepas",
  "block.minecraft.stripped_birch_log": "Gelondong berk koepas",
  "block.minecraft.stripped_birch_wood": "Kajoe berk koepas",
  "block.minecraft.stripped_cherry_log": "Gelondong kersen koepas",
  "block.minecraft.stripped_cherry_wood": "Kajoe kersen koepas",
  "block.minecraft.stripped_crimson_hyphae": "Benang koelat kirmizi koepas",
  "block.minecraft.stripped_crimson_stem": "Batang kirmizi koepas",
  "block.minecraft.stripped_dark_oak_log": "Gelondong eik gelap koepas",
  "block.minecraft.stripped_dark_oak_wood": "Kajoe eik gelap koepas",
  "block.minecraft.stripped_jungle_log": "Gelondong rimba koepas",
  "block.minecraft.stripped_jungle_wood": "Kajoe rimba koepas",
  "block.minecraft.stripped_mangrove_log": "Gelondong bakau koepas",
  "block.minecraft.stripped_mangrove_wood": "Kajoe bakau koepas",
  "block.minecraft.stripped_oak_log": "Gelondong eik koepas",
  "block.minecraft.stripped_oak_wood": "Kajoe eik koepas",
  "block.minecraft.stripped_pale_oak_log": "Gelondong eik poetjat koepas",
  "block.minecraft.stripped_pale_oak_wood": "Kajoe eik poetjat koepas",
  "block.minecraft.stripped_spruce_log": "Gelondong tjemara koepas",
  "block.minecraft.stripped_spruce_wood": "Kajoe tjemara koepas",
  "block.minecraft.stripped_warped_hyphae": "Benang koelat keroekoet koepas",
  "block.minecraft.stripped_warped_stem": "Batang keroekoet koepas",
  "block.minecraft.structure_block": "Balok bangoenan",
  "block.minecraft.structure_void": "Hampa bangoenan",
  "block.minecraft.sugar_cane": "Teboe",
  "block.minecraft.sunflower": "Boenga matahari",
  "block.minecraft.suspicious_gravel": "Kerikil mentjoerigakan",
  "block.minecraft.suspicious_sand": "Pasir mentjoerigakan",
  "block.minecraft.sweet_berry_bush": "Semak boeni manis",
  "block.minecraft.tall_dry_grass": "Roempoet kering tinggi",
  "block.minecraft.tall_grass": "Roempoet tinggi",
  "block.minecraft.tall_seagrass": "Latoeh tinggi",
  "block.minecraft.target": "Sasaran",
  "block.minecraft.terracotta": "Térakota",
  "block.minecraft.test_block": "Balok oedji",
  "block.minecraft.test_instance_block": "Balok instansi oedji",
  "block.minecraft.tinted_glass": "Katja gelap",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Ledakan TNT dimatikan",
  "block.minecraft.torch": "Obor",
  "block.minecraft.torchflower": "Boenga obor",
  "block.minecraft.torchflower_crop": "Tanaman boenga obor",
  "block.minecraft.trapped_chest": "Peti djebakan",
  "block.minecraft.trial_spawner": "Pembangkit tjobaän",
  "block.minecraft.tripwire": "Kawat senggol",
  "block.minecraft.tripwire_hook": "Pengaït kawat senggol",
  "block.minecraft.tube_coral": "Karang pipa",
  "block.minecraft.tube_coral_block": "Balok karang pipa",
  "block.minecraft.tube_coral_fan": "Kipas laoet pipa",
  "block.minecraft.tube_coral_wall_fan": "Kipas laoet pipa dinding",
  "block.minecraft.tuff": "Batoe aboe",
  "block.minecraft.tuff_brick_slab": "Pelat bata batoe aboe",
  "block.minecraft.tuff_brick_stairs": "Tangga bata batoe aboe",
  "block.minecraft.tuff_brick_wall": "Tembok bata batoe aboe",
  "block.minecraft.tuff_bricks": "Bata batoe aboe",
  "block.minecraft.tuff_slab": "Pelat batoe aboe",
  "block.minecraft.tuff_stairs": "Tangga batoe aboe",
  "block.minecraft.tuff_wall": "Tembok batoe aboe",
  "block.minecraft.turtle_egg": "Teloer penjoe",
  "block.minecraft.twisting_vines": "Perambat melilit",
  "block.minecraft.twisting_vines_plant": "Tanaman perambat melilit",
  "block.minecraft.vault": "Brankas",
  "block.minecraft.verdant_froglight": "Lampoe katak menghidjau",
  "block.minecraft.vine": "Toemboehan merambat",
  "block.minecraft.void_air": "Oedara hampa",
  "block.minecraft.wall_torch": "Obor dinding",
  "block.minecraft.warped_button": "Kenop keroekoet",
  "block.minecraft.warped_door": "Pintoe keroekoet",
  "block.minecraft.warped_fence": "Pagar keroekoet",
  "block.minecraft.warped_fence_gate": "Pintoe pagar keroekoet",
  "block.minecraft.warped_fungus": "Djamoer keroekoet",
  "block.minecraft.warped_hanging_sign": "Papan tanda gantoeng keroekoet",
  "block.minecraft.warped_hyphae": "Benang koelat keroekoet",
  "block.minecraft.warped_nylium": "Djenaring keroekoet",
  "block.minecraft.warped_planks": "Papan keroekoet",
  "block.minecraft.warped_pressure_plate": "Pelat penekan keroekoet",
  "block.minecraft.warped_roots": "Akar keroekoet",
  "block.minecraft.warped_shelf": "Rak keroekoet",
  "block.minecraft.warped_sign": "Papan tanda keroekoet",
  "block.minecraft.warped_slab": "Pelat keroekoet",
  "block.minecraft.warped_stairs": "Tangga keroekoet",
  "block.minecraft.warped_stem": "Batang keroekoet",
  "block.minecraft.warped_trapdoor": "Pintoe kolong keroekoet",
  "block.minecraft.warped_wall_hanging_sign": "Papan tanda gantoeng dinding keroekoet",
  "block.minecraft.warped_wall_sign": "Papan tanda dinding keroekoet",
  "block.minecraft.warped_wart_block": "Balok ketoeat keroekoet",
  "block.minecraft.water": "Aïr",
  "block.minecraft.water_cauldron": "Koeali aïr",
  "block.minecraft.waxed_chiseled_copper": "Tembaga pahatan berlilin",
  "block.minecraft.waxed_copper_bars": "Terali tembaga berlilin",
  "block.minecraft.waxed_copper_block": "Balok tembaga berlilin",
  "block.minecraft.waxed_copper_bulb": "Bohlam tembaga berlilin",
  "block.minecraft.waxed_copper_chain": "Rantai tembaga berlilin",
  "block.minecraft.waxed_copper_chest": "Peti tembaga berlilin",
  "block.minecraft.waxed_copper_door": "Pintoe tembaga berlilin",
  "block.minecraft.waxed_copper_golem_statue": "Patoeng golem tembaga berlilin",
  "block.minecraft.waxed_copper_grate": "Kisi-kisi tembaga berlilin",
  "block.minecraft.waxed_copper_lantern": "Lentera tembaga berlilin",
  "block.minecraft.waxed_copper_trapdoor": "Pintoe kolong tembaga berlilin",
  "block.minecraft.waxed_cut_copper": "Tembaga potongan berlilin",
  "block.minecraft.waxed_cut_copper_slab": "Pelat tembaga potongan berlilin",
  "block.minecraft.waxed_cut_copper_stairs": "Tangga tembaga potongan berlilin",
  "block.minecraft.waxed_exposed_chiseled_copper": "Tembaga pahatan terbeber berlilin",
  "block.minecraft.waxed_exposed_copper": "Tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_bars": "Terali tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_bulb": "Bohlam tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_chain": "Rantai tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_chest": "Peti tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_door": "Pintoe tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Patoeng golem tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_grate": "Kisi-kisi tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_lantern": "Lentera tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Pintoe kolong tembaga terbeber berlilin",
  "block.minecraft.waxed_exposed_cut_copper": "Tembaga potongan terbeber berlilin",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Pelat tembaga potongan terbeber berlilin",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Tangga tembaga potongan terbeber berlilin",
  "block.minecraft.waxed_exposed_lightning_rod": "Penangkal petir terbeber berlilin",
  "block.minecraft.waxed_lightning_rod": "Penangkal petir berlilin",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Tembaga pahatan teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper": "Tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_bars": "Terali tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bohlam tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_chain": "Rantai tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_chest": "Peti tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_door": "Pintoe tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Patoeng golem tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_grate": "Kisi-kisi tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lentera tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Pintoe kolong tembaga teroksidir berlilin",
  "block.minecraft.waxed_oxidized_cut_copper": "Tembaga potongan teroksidir berlilin",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Pelat tembaga potongan teroksidir berlilin",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Tangga tembaga potongan teroksidir berlilin",
  "block.minecraft.waxed_oxidized_lightning_rod": "Penangkal petir teroksidir berlilin",
  "block.minecraft.waxed_weathered_chiseled_copper": "Tembaga pahatan berkarat berlilin",
  "block.minecraft.waxed_weathered_copper": "Tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_bars": "Terali tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_bulb": "Bohlam tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_chain": "Rantai tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_chest": "Peti tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_door": "Pintoe tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Patoeng golem tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_grate": "Kisi-kisi tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_lantern": "Lentera tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Pintoe kolong tembaga berkarat berlilin",
  "block.minecraft.waxed_weathered_cut_copper": "Tembaga potongan berkarat berlilin",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Pelat tembaga potongan berkarat berlilin",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Tangga tembaga potongan berkarat berlilin",
  "block.minecraft.waxed_weathered_lightning_rod": "Penangkal petir berkarat berlilin",
  "block.minecraft.weathered_chiseled_copper": "Tembaga pahatan berkarat",
  "block.minecraft.weathered_copper": "Tembaga berkarat",
  "block.minecraft.weathered_copper_bars": "Terali tembaga berkarat",
  "block.minecraft.weathered_copper_bulb": "Bohlam tembaga berkarat",
  "block.minecraft.weathered_copper_chain": "Rantai tembaga berkarat",
  "block.minecraft.weathered_copper_chest": "Peti tembaga berkarat",
  "block.minecraft.weathered_copper_door": "Pintoe tembaga berkarat",
  "block.minecraft.weathered_copper_golem_statue": "Patoeng golem tembaga berkarat",
  "block.minecraft.weathered_copper_grate": "Kisi-kisi tembaga berkarat",
  "block.minecraft.weathered_copper_lantern": "Lentera tembaga berkarat",
  "block.minecraft.weathered_copper_trapdoor": "Pintoe kolong tembaga berkarat",
  "block.minecraft.weathered_cut_copper": "Tembaga potongan berkarat",
  "block.minecraft.weathered_cut_copper_slab": "Pelat tembaga potongan berkarat",
  "block.minecraft.weathered_cut_copper_stairs": "Tangga tembaga potongan berkarat",
  "block.minecraft.weathered_lightning_rod": "Penangkal petir berkarat",
  "block.minecraft.weeping_vines": "Perambat berkoelai",
  "block.minecraft.weeping_vines_plant": "Tanaman perambat berkoelai",
  "block.minecraft.wet_sponge": "Spons basah",
  "block.minecraft.wheat": "Gandoem",
  "block.minecraft.white_banner": "Pandji poetih",
  "block.minecraft.white_bed": "Katil poetih",
  "block.minecraft.white_candle": "Lilin poetih",
  "block.minecraft.white_candle_cake": "Tar dengan lilin poetih",
  "block.minecraft.white_carpet": "Ambal poetih",
  "block.minecraft.white_concrete": "Beton poetih",
  "block.minecraft.white_concrete_powder": "Semen poetih",
  "block.minecraft.white_glazed_terracotta": "Tembikar poetih",
  "block.minecraft.white_shulker_box": "Kotak shulker poetih",
  "block.minecraft.white_stained_glass": "Katja poetih",
  "block.minecraft.white_stained_glass_pane": "Panel katja poetih",
  "block.minecraft.white_terracotta": "Térakota poetih",
  "block.minecraft.white_tulip": "Tulp poetih",
  "block.minecraft.white_wool": "Wol poetih",
  "block.minecraft.wildflowers": "Boenga liar",
  "block.minecraft.wither_rose": "Mawar Wither",
  "block.minecraft.wither_skeleton_skull": "Tengkorak bengkarak Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Tengkorak dinding bengkarak Wither",
  "block.minecraft.yellow_banner": "Pandji koening",
  "block.minecraft.yellow_bed": "Katil koening",
  "block.minecraft.yellow_candle": "Lilin koening",
  "block.minecraft.yellow_candle_cake": "Tar dengan lilin koening",
  "block.minecraft.yellow_carpet": "Ambal koening",
  "block.minecraft.yellow_concrete": "Beton koening",
  "block.minecraft.yellow_concrete_powder": "Semen koening",
  "block.minecraft.yellow_glazed_terracotta": "Tembikar koening",
  "block.minecraft.yellow_shulker_box": "Kotak shulker koening",
  "block.minecraft.yellow_stained_glass": "Katja koening",
  "block.minecraft.yellow_stained_glass_pane": "Panel katja koening",
  "block.minecraft.yellow_terracotta": "Térakota koening",
  "block.minecraft.yellow_wool": "Wol koening",
  "block.minecraft.zombie_head": "Kepala zombi",
  "block.minecraft.zombie_wall_head": "Kepala dinding zombi",
  "item.minecraft.acacia_boat": "Perahoe pilang",
  "item.minecraft.acacia_chest_boat": "Perahoe pilang dengan peti",
  "item.minecraft.allay_spawn_egg": "Teloer pewoedjoedan peringan",
  "item.minecraft.amethyst_shard": "Serpihan ketjoeboeng",
  "item.minecraft.angler_pottery_shard": "Serpihan pasoe „pengaïl”",
  "item.minecraft.angler_pottery_sherd": "Serpihan pasoe „pengaïl”",
  "item.minecraft.apple": "Apel",
  "item.minecraft.archer_pottery_shard": "Serpihan pasoe „pemanah”",
  "item.minecraft.archer_pottery_sherd": "Serpihan pasoe „pemanah”",
  "item.minecraft.armadillo_scute": "Sisik armadilo",
  "item.minecraft.armadillo_spawn_egg": "Teloer pewoedjoedan armadilo",
  "item.minecraft.armor_stand": "Tjagak zirah",
  "item.minecraft.arms_up_pottery_shard": "Serpihan pasoe „angkat tangan”",
  "item.minecraft.arms_up_pottery_sherd": "Serpihan pasoe „angkat tangan”",
  "item.minecraft.arrow": "Panah",
  "item.minecraft.axolotl_bucket": "Ember axolotl",
  "item.minecraft.axolotl_spawn_egg": "Teloer pewoedjoedan axolotl",
  "item.minecraft.baked_potato": "Kentang panggang",
  "item.minecraft.bamboo_chest_raft": "Rakit bamboe dengan peti",
  "item.minecraft.bamboo_raft": "Rakit bamboe",
  "item.minecraft.bat_spawn_egg": "Teloer pewoedjoedan kelelawar",
  "item.minecraft.bee_spawn_egg": "Teloer pewoedjoedan lebah",
  "item.minecraft.beef": "Daging sapi mentah",
  "item.minecraft.beetroot": "Bit",
  "item.minecraft.beetroot_seeds": "Benih bit",
  "item.minecraft.beetroot_soup": "Soep bit",
  "item.minecraft.birch_boat": "Perahoe berk",
  "item.minecraft.birch_chest_boat": "Perahoe berk dengan peti",
  "item.minecraft.black_bundle": "Kantong hitam",
  "item.minecraft.black_dye": "Pewarna hitam",
  "item.minecraft.black_harness": "Roengkoep hitam",
  "item.minecraft.blade_pottery_shard": "Serpihan pasoe „bilah”",
  "item.minecraft.blade_pottery_sherd": "Serpihan pasoe „bilah”",
  "item.minecraft.blaze_powder": "Poeder kemamang",
  "item.minecraft.blaze_rod": "Tongkat kemamang",
  "item.minecraft.blaze_spawn_egg": "Teloer pewoedjoedan kemamang",
  "item.minecraft.blue_bundle": "Kantong biroe",
  "item.minecraft.blue_dye": "Pewarna biroe",
  "item.minecraft.blue_egg": "Teloer biroe",
  "item.minecraft.blue_harness": "Roengkoep biroe",
  "item.minecraft.bogged_spawn_egg": "Teloer pewoedjoedan lapoekan",
  "item.minecraft.bolt_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Hiasan zirah „bout”",
  "item.minecraft.bone": "Toelang",
  "item.minecraft.bone_meal": "Tepoeng toelang",
  "item.minecraft.book": "Boekoe",
  "item.minecraft.bordure_indented_banner_pattern": "Patron pandji „tepi bertakik”",
  "item.minecraft.bow": "Boesoer",
  "item.minecraft.bowl": "Mangkoek",
  "item.minecraft.bread": "Roti",
  "item.minecraft.breeze_rod": "Tongkat pawana",
  "item.minecraft.breeze_spawn_egg": "Teloer pewoedjoedan pawana",
  "item.minecraft.brewer_pottery_shard": "Serpihan pasoe „peramoe”",
  "item.minecraft.brewer_pottery_sherd": "Serpihan pasoe „peramoe”",
  "item.minecraft.brewing_stand": "Standar peramoean",
  "item.minecraft.brick": "Bata",
  "item.minecraft.brown_bundle": "Kantong sawo matang",
  "item.minecraft.brown_dye": "Pewarna sawo matang",
  "item.minecraft.brown_egg": "Teloer sawo matang",
  "item.minecraft.brown_harness": "Roengkoep sawo matang",
  "item.minecraft.brush": "Sikat",
  "item.minecraft.bucket": "Ember",
  "item.minecraft.bundle": "Kantong",
  "item.minecraft.bundle.empty": "Kosong",
  "item.minecraft.bundle.empty.description": "Dapat menjimpan toempoekan benda tjampoer",
  "item.minecraft.bundle.full": "Penoeh",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Serpihan pasoe „api”",
  "item.minecraft.burn_pottery_sherd": "Serpihan pasoe „api”",
  "item.minecraft.camel_husk_spawn_egg": "Teloer pewoedjoedan oenta beloelang",
  "item.minecraft.camel_spawn_egg": "Teloer pewoedjoedan oenta",
  "item.minecraft.carrot": "Wortel",
  "item.minecraft.carrot_on_a_stick": "Wortel ditongkat",
  "item.minecraft.cat_spawn_egg": "Teloer pewoedjoedan koetjing",
  "item.minecraft.cauldron": "Koeali",
  "item.minecraft.cave_spider_spawn_egg": "Teloer pewoedjoedan laba-laba goea",
  "item.minecraft.chainmail_boots": "Lars rantai",
  "item.minecraft.chainmail_chestplate": "Badjoe rantai",
  "item.minecraft.chainmail_helmet": "Helm rantai",
  "item.minecraft.chainmail_leggings": "Tjelana rantai",
  "item.minecraft.charcoal": "Arang",
  "item.minecraft.cherry_boat": "Perahoe kersen",
  "item.minecraft.cherry_chest_boat": "Perahoe kersen dengan peti",
  "item.minecraft.chest_minecart": "Kereta tambang dengan peti",
  "item.minecraft.chicken": "Daging ajam mentah",
  "item.minecraft.chicken_spawn_egg": "Teloer pewoedjoedan ajam",
  "item.minecraft.chorus_fruit": "Boeah koor",
  "item.minecraft.clay_ball": "Bola tanah liat",
  "item.minecraft.clock": "Djam",
  "item.minecraft.coal": "Batoe bara",
  "item.minecraft.coast_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Hiasan zirah „pesisir”",
  "item.minecraft.cocoa_beans": "Bidji kakao",
  "item.minecraft.cod": "Bakalau mentah",
  "item.minecraft.cod_bucket": "Ember bakalau",
  "item.minecraft.cod_spawn_egg": "Teloer pewoedjoedan bakalau",
  "item.minecraft.command_block_minecart": "Kereta tambang dengan balok perintah",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Bistik",
  "item.minecraft.cooked_chicken": "Daging ajam panggang",
  "item.minecraft.cooked_cod": "Bakalau matang",
  "item.minecraft.cooked_mutton": "Daging domba panggang",
  "item.minecraft.cooked_porkchop": "Daging babi panggang",
  "item.minecraft.cooked_rabbit": "Daging kelintji panggang",
  "item.minecraft.cooked_salmon": "Salem matang",
  "item.minecraft.cookie": "Koeé kering",
  "item.minecraft.copper_axe": "Kapak tembaga",
  "item.minecraft.copper_boots": "Lars tembaga",
  "item.minecraft.copper_chestplate": "Badjoe tembaga",
  "item.minecraft.copper_golem_spawn_egg": "Teloer pewoedjoedan golem tembaga",
  "item.minecraft.copper_helmet": "Helm tembaga",
  "item.minecraft.copper_hoe": "Tjangkoel tembaga",
  "item.minecraft.copper_horse_armor": "Zirah koeda tembaga",
  "item.minecraft.copper_ingot": "Tembaga batangan",
  "item.minecraft.copper_leggings": "Tjelana tembaga",
  "item.minecraft.copper_nautilus_armor": "Zirah genggeng tembaga",
  "item.minecraft.copper_nugget": "Bongkahan tembaga",
  "item.minecraft.copper_pickaxe": "Belioeng tembaga",
  "item.minecraft.copper_shovel": "Sekop tembaga",
  "item.minecraft.copper_spear": "Tombak tembaga",
  "item.minecraft.copper_sword": "Pedang tembaga",
  "item.minecraft.cow_spawn_egg": "Teloer pewoedjoedan sapi",
  "item.minecraft.creaking_spawn_egg": "Teloer pewoedjoedan kerioet",
  "item.minecraft.creeper_banner_pattern": "Patron pandji",
  "item.minecraft.creeper_banner_pattern.desc": "Roepa creeper",
  "item.minecraft.creeper_banner_pattern.new": "Patron pandji „roepa creeper”",
  "item.minecraft.creeper_spawn_egg": "Teloer pewoedjoedan creeper",
  "item.minecraft.crossbow": "Boesoer silang",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Kantong nilangsoeka",
  "item.minecraft.cyan_dye": "Pewarna nilangsoeka",
  "item.minecraft.cyan_harness": "Roengkoep nilangsoeka",
  "item.minecraft.danger_pottery_shard": "Serpihan pasoe „bahaja”",
  "item.minecraft.danger_pottery_sherd": "Serpihan pasoe „bahaja”",
  "item.minecraft.dark_oak_boat": "Perahoe eik gelap",
  "item.minecraft.dark_oak_chest_boat": "Perahoe eik gelap dengan peti",
  "item.minecraft.debug_stick": "Tongkat lepas-koetoe",
  "item.minecraft.debug_stick.empty": "%s tidak poenja sifat",
  "item.minecraft.debug_stick.select": " „%s” (%s) dipilih",
  "item.minecraft.debug_stick.update": "„%s” -> %s",
  "item.minecraft.diamond": "Berlian",
  "item.minecraft.diamond_axe": "Kapak berlian",
  "item.minecraft.diamond_boots": "Lars berlian",
  "item.minecraft.diamond_chestplate": "Badjoe berlian",
  "item.minecraft.diamond_helmet": "Helm berlian",
  "item.minecraft.diamond_hoe": "Tjangkoel berlian",
  "item.minecraft.diamond_horse_armor": "Zirah koeda berlian",
  "item.minecraft.diamond_leggings": "Tjelana berlian",
  "item.minecraft.diamond_nautilus_armor": "Zirah genggeng berlian",
  "item.minecraft.diamond_pickaxe": "Belioeng berlian",
  "item.minecraft.diamond_shovel": "Sekop berlian",
  "item.minecraft.diamond_spear": "Tombak berlian",
  "item.minecraft.diamond_sword": "Pedang berlian",
  "item.minecraft.disc_fragment_5": "Fragmen pelat",
  "item.minecraft.disc_fragment_5.desc": "Pelat muziek - 5",
  "item.minecraft.dolphin_spawn_egg": "Teloer pewoedjoedan loemba-loemba",
  "item.minecraft.donkey_spawn_egg": "Teloer pewoedjoedan keledai",
  "item.minecraft.dragon_breath": "Napas Naga",
  "item.minecraft.dried_kelp": "Komboe kering",
  "item.minecraft.drowned_spawn_egg": "Teloer pewoedjoedan hanjoetan",
  "item.minecraft.dune_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Hiasan zirah „goemoek”",
  "item.minecraft.echo_shard": "Serpihan gaoeng",
  "item.minecraft.egg": "Teloer",
  "item.minecraft.elder_guardian_spawn_egg": "Teloer pewoedjoedan tetoea pendjaga",
  "item.minecraft.elytra": "Elitron",
  "item.minecraft.emerald": "Zamroed",
  "item.minecraft.enchanted_book": "Boekoe pesona",
  "item.minecraft.enchanted_golden_apple": "Apel emas terpesona",
  "item.minecraft.end_crystal": "Kristal End",
  "item.minecraft.ender_dragon_spawn_egg": "Teloer pewoedjoedan Naga Ender",
  "item.minecraft.ender_eye": "Mata Ender",
  "item.minecraft.ender_pearl": "Moetiara Ender",
  "item.minecraft.enderman_spawn_egg": "Teloer pewoedjoedan enderman",
  "item.minecraft.endermite_spawn_egg": "Teloer pewoedjoedan endermite",
  "item.minecraft.evoker_spawn_egg": "Teloer pewoedjoedan pawang",
  "item.minecraft.experience_bottle": "Botol memesona",
  "item.minecraft.explorer_pottery_shard": "Serpihan pasoe „pendjeladjah”",
  "item.minecraft.explorer_pottery_sherd": "Serpihan pasoe „pendjeladjah”",
  "item.minecraft.eye_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Hiasan zirah „mata”",
  "item.minecraft.feather": "Boeloe",
  "item.minecraft.fermented_spider_eye": "Mata laba-laba beragi",
  "item.minecraft.field_masoned_banner_pattern": "Patron pandji „bataän”",
  "item.minecraft.filled_map": "Peta",
  "item.minecraft.fire_charge": "Bola api",
  "item.minecraft.firework_rocket": "Roket kembang api",
  "item.minecraft.firework_rocket.flight": "Lama terbang:",
  "item.minecraft.firework_rocket.multiple_stars": "%s sebanjak %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Bintang kembang api",
  "item.minecraft.firework_star.black": "Hitam",
  "item.minecraft.firework_star.blue": "Biroe",
  "item.minecraft.firework_star.brown": "Sawo matang",
  "item.minecraft.firework_star.custom_color": "Tersoeai",
  "item.minecraft.firework_star.cyan": "Nilangsoeka",
  "item.minecraft.firework_star.fade_to": "Poedar mendjadi",
  "item.minecraft.firework_star.flicker": "Berkelip",
  "item.minecraft.firework_star.gray": "Kelaboe",
  "item.minecraft.firework_star.green": "Hidjau",
  "item.minecraft.firework_star.light_blue": "Biroe moeda",
  "item.minecraft.firework_star.light_gray": "Kelaboe moeda",
  "item.minecraft.firework_star.lime": "Hidjau poepoes",
  "item.minecraft.firework_star.magenta": "Patma",
  "item.minecraft.firework_star.orange": "Oranje",
  "item.minecraft.firework_star.pink": "Djambon",
  "item.minecraft.firework_star.purple": "Oengoe",
  "item.minecraft.firework_star.red": "Merah",
  "item.minecraft.firework_star.shape": "Bentoek ta' dikenal",
  "item.minecraft.firework_star.shape.burst": "Meledak",
  "item.minecraft.firework_star.shape.creeper": "Roepa creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola besar",
  "item.minecraft.firework_star.shape.small_ball": "Bola ketjil",
  "item.minecraft.firework_star.shape.star": "Roepa bintang",
  "item.minecraft.firework_star.trail": "Berdjedjak",
  "item.minecraft.firework_star.white": "Poetih",
  "item.minecraft.firework_star.yellow": "Koening",
  "item.minecraft.fishing_rod": "Pantjing",
  "item.minecraft.flint": "Batoe api",
  "item.minecraft.flint_and_steel": "Pemantik api",
  "item.minecraft.flow_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Hiasan zirah „pilin”",
  "item.minecraft.flow_banner_pattern": "Patron pandji",
  "item.minecraft.flow_banner_pattern.desc": "Pilin",
  "item.minecraft.flow_banner_pattern.new": "Patron pandji „pilin”",
  "item.minecraft.flow_pottery_sherd": "Serpihan pasoe „pilin”",
  "item.minecraft.flower_banner_pattern": "Patron pandji",
  "item.minecraft.flower_banner_pattern.desc": "Roepa boenga",
  "item.minecraft.flower_banner_pattern.new": "Patron pandji „roepa boenga”",
  "item.minecraft.flower_pot": "Pot boenga",
  "item.minecraft.fox_spawn_egg": "Teloer pewoedjoedan roebah",
  "item.minecraft.friend_pottery_shard": "Serpihan pasoe „kawan”",
  "item.minecraft.friend_pottery_sherd": "Serpihan pasoe „kawan”",
  "item.minecraft.frog_spawn_egg": "Teloer pewoedjoedan katak",
  "item.minecraft.furnace_minecart": "Kereta tambang dengan oven",
  "item.minecraft.ghast_spawn_egg": "Teloer pewoedjoedan ghast",
  "item.minecraft.ghast_tear": "Aïr mata ghast",
  "item.minecraft.glass_bottle": "Botol katja",
  "item.minecraft.glistering_melon_slice": "Irisan semangka emas",
  "item.minecraft.globe_banner_pattern": "Patron pandji",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Patron pandji „globe”",
  "item.minecraft.glow_berries": "Boeni sinar",
  "item.minecraft.glow_ink_sac": "Kantong tinta sinar",
  "item.minecraft.glow_item_frame": "Bingkai benda sinar",
  "item.minecraft.glow_squid_spawn_egg": "Teloer pewoedjoedan tjoemi-tjoemi sinar",
  "item.minecraft.glowstone_dust": "Serboek batoe sinar",
  "item.minecraft.goat_horn": "Tandoek kambing",
  "item.minecraft.goat_spawn_egg": "Teloer pewoedjoedan kambing",
  "item.minecraft.gold_ingot": "Emas batangan",
  "item.minecraft.gold_nugget": "Bongkahan emas",
  "item.minecraft.golden_apple": "Apel emas",
  "item.minecraft.golden_axe": "Kapak emas",
  "item.minecraft.golden_boots": "Lars emas",
  "item.minecraft.golden_carrot": "Wortel emas",
  "item.minecraft.golden_chestplate": "Badjoe emas",
  "item.minecraft.golden_helmet": "Helm emas",
  "item.minecraft.golden_hoe": "Tjangkoel emas",
  "item.minecraft.golden_horse_armor": "Zirah koeda emas",
  "item.minecraft.golden_leggings": "Tjelana emas",
  "item.minecraft.golden_nautilus_armor": "Zirah genggeng emas",
  "item.minecraft.golden_pickaxe": "Belioeng emas",
  "item.minecraft.golden_shovel": "Sekop emas",
  "item.minecraft.golden_spear": "Tombak emas",
  "item.minecraft.golden_sword": "Pedang emas",
  "item.minecraft.gray_bundle": "Kantong kelaboe",
  "item.minecraft.gray_dye": "Pewarna kelaboe",
  "item.minecraft.gray_harness": "Roengkoep kelaboe",
  "item.minecraft.green_bundle": "Kantong hidjau",
  "item.minecraft.green_dye": "Pewarna hidjau",
  "item.minecraft.green_harness": "Roengkoep hidjau",
  "item.minecraft.guardian_spawn_egg": "Teloer pewoedjoedan pendjaga",
  "item.minecraft.gunpowder": "Poeder mesioe",
  "item.minecraft.guster_banner_pattern": "Patron pandji",
  "item.minecraft.guster_banner_pattern.desc": "Prahara",
  "item.minecraft.guster_banner_pattern.new": "Patron pandji „prahara”",
  "item.minecraft.guster_pottery_sherd": "Serpihan pasoe „prahara”",
  "item.minecraft.happy_ghast_spawn_egg": "Teloer pewoedjoedan ghast riang",
  "item.minecraft.harness": "Roengkoep",
  "item.minecraft.heart_of_the_sea": "Djantoeng laoet",
  "item.minecraft.heart_pottery_shard": "Serpihan pasoe „hati”",
  "item.minecraft.heart_pottery_sherd": "Serpihan pasoe „hati”",
  "item.minecraft.heartbreak_pottery_shard": "Serpihan pasoe „patah hati”",
  "item.minecraft.heartbreak_pottery_sherd": "Serpihan pasoe „patah hati”",
  "item.minecraft.hoglin_spawn_egg": "Teloer pewoedjoedan hoglin",
  "item.minecraft.honey_bottle": "Botol madoe",
  "item.minecraft.honeycomb": "Sarang madoe",
  "item.minecraft.hopper_minecart": "Kereta tambang dengan tjorong",
  "item.minecraft.horse_spawn_egg": "Teloer pewoedjoedan koeda",
  "item.minecraft.host_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.host_armor_trim_smithing_template.new": "Hiasan zirah „toean roemah”",
  "item.minecraft.howl_pottery_shard": "Serpihan pasoe „lolong”",
  "item.minecraft.howl_pottery_sherd": "Serpihan pasoe „lolong”",
  "item.minecraft.husk_spawn_egg": "Teloer pewoedjoedan beloelang",
  "item.minecraft.ink_sac": "Kantong tinta",
  "item.minecraft.iron_axe": "Kapak besi",
  "item.minecraft.iron_boots": "Lars besi",
  "item.minecraft.iron_chestplate": "Badjoe besi",
  "item.minecraft.iron_golem_spawn_egg": "Teloer pewoedjoedan golem besi",
  "item.minecraft.iron_helmet": "Helm besi",
  "item.minecraft.iron_hoe": "Tjangkoel besi",
  "item.minecraft.iron_horse_armor": "Zirah koeda besi",
  "item.minecraft.iron_ingot": "Besi batangan",
  "item.minecraft.iron_leggings": "Tjelana besi",
  "item.minecraft.iron_nautilus_armor": "Zirah genggeng besi",
  "item.minecraft.iron_nugget": "Bongkahan besi",
  "item.minecraft.iron_pickaxe": "Belioeng besi",
  "item.minecraft.iron_shovel": "Sekop besi",
  "item.minecraft.iron_spear": "Tombak besi",
  "item.minecraft.iron_sword": "Pedang besi",
  "item.minecraft.item_frame": "Bingkai benda",
  "item.minecraft.jungle_boat": "Perahoe rimba",
  "item.minecraft.jungle_chest_boat": "Perahoe rimba dengan peti",
  "item.minecraft.knowledge_book": "Boekoe pengetahoean",
  "item.minecraft.lapis_lazuli": "Lazoewardi",
  "item.minecraft.lava_bucket": "Ember lava",
  "item.minecraft.lead": "Tali pengikat",
  "item.minecraft.leather": "Koelit",
  "item.minecraft.leather_boots": "Lars koelit",
  "item.minecraft.leather_chestplate": "Badjoe koelit",
  "item.minecraft.leather_helmet": "Topi koelit",
  "item.minecraft.leather_horse_armor": "Zirah koeda koelit",
  "item.minecraft.leather_leggings": "Tjelana koelit",
  "item.minecraft.light_blue_bundle": "Kantong biroe moeda",
  "item.minecraft.light_blue_dye": "Pewarna biroe moeda",
  "item.minecraft.light_blue_harness": "Roengkoep biroe moeda",
  "item.minecraft.light_gray_bundle": "Kantong kelaboe moeda",
  "item.minecraft.light_gray_dye": "Pewarna kelaboe moeda",
  "item.minecraft.light_gray_harness": "Roengkoep kelaboe moeda",
  "item.minecraft.lime_bundle": "Kantong hidjau poepoes",
  "item.minecraft.lime_dye": "Pewarna hidjau poepoes",
  "item.minecraft.lime_harness": "Roengkoep hidjau poepoes",
  "item.minecraft.lingering_potion": "Ramoean bertahan",
  "item.minecraft.lingering_potion.effect.awkward": "Ramoean bertahan aneh",
  "item.minecraft.lingering_potion.effect.empty": "Ramoean bertahan ta' bisa diboeat",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Ramoean bertahan kebal api",
  "item.minecraft.lingering_potion.effect.harming": "Ramoean bertahan kesakitan",
  "item.minecraft.lingering_potion.effect.healing": "Ramoean bertahan penjemboehan",
  "item.minecraft.lingering_potion.effect.infested": "Ramoean bertahan infestasi",
  "item.minecraft.lingering_potion.effect.invisibility": "Ramoean bertahan halimoenan",
  "item.minecraft.lingering_potion.effect.leaping": "Ramoean bertahan lompatan",
  "item.minecraft.lingering_potion.effect.levitation": "Ramoean bertahan pengapoengan",
  "item.minecraft.lingering_potion.effect.luck": "Ramoean bertahan keberoentoengan",
  "item.minecraft.lingering_potion.effect.mundane": "Ramoean bertahan biasa",
  "item.minecraft.lingering_potion.effect.night_vision": "Ramoean bertahan penglihatan gelap",
  "item.minecraft.lingering_potion.effect.oozing": "Ramoean bertahan pentjoetjoeran",
  "item.minecraft.lingering_potion.effect.poison": "Ramoean bertahan ratjoen",
  "item.minecraft.lingering_potion.effect.regeneration": "Ramoean bertahan regenerasi",
  "item.minecraft.lingering_potion.effect.slow_falling": "Ramoean bertahan djatoeh lambat",
  "item.minecraft.lingering_potion.effect.slowness": "Ramoean bertahan kelambatan",
  "item.minecraft.lingering_potion.effect.strength": "Ramoean bertahan kekoeatan",
  "item.minecraft.lingering_potion.effect.swiftness": "Ramoean bertahan ketjepatan",
  "item.minecraft.lingering_potion.effect.thick": "Ramoean bertahan kental",
  "item.minecraft.lingering_potion.effect.turtle_master": "Ramoean bertahan goeroe penjoe",
  "item.minecraft.lingering_potion.effect.water": "Botol aïr bertahan",
  "item.minecraft.lingering_potion.effect.water_breathing": "Ramoean bertahan pernapasan aïr",
  "item.minecraft.lingering_potion.effect.weakness": "Ramoean bertahan kelemahan",
  "item.minecraft.lingering_potion.effect.weaving": "Ramoean bertahan meradjoet",
  "item.minecraft.lingering_potion.effect.wind_charged": "Ramoean bertahan emboesan",
  "item.minecraft.llama_spawn_egg": "Teloer pewoedjoedan lama",
  "item.minecraft.lodestone_compass": "Kompas batoe magnet",
  "item.minecraft.mace": "Belantan",
  "item.minecraft.magenta_bundle": "Kantong patma",
  "item.minecraft.magenta_dye": "Pewarna patma",
  "item.minecraft.magenta_harness": "Roengkoep patma",
  "item.minecraft.magma_cream": "Krém magma",
  "item.minecraft.magma_cube_spawn_egg": "Teloer pewoedjoedan dadoe magma",
  "item.minecraft.mangrove_boat": "Perahoe bakau",
  "item.minecraft.mangrove_chest_boat": "Perahoe bakau dengan peti",
  "item.minecraft.map": "Peta kosong",
  "item.minecraft.melon_seeds": "Benih semangka",
  "item.minecraft.melon_slice": "Irisan semangka",
  "item.minecraft.milk_bucket": "Ember soesoe",
  "item.minecraft.minecart": "Kereta tambang",
  "item.minecraft.miner_pottery_shard": "Serpihan pasoe „penambang”",
  "item.minecraft.miner_pottery_sherd": "Serpihan pasoe „penambang”",
  "item.minecraft.mojang_banner_pattern": "Patron pandji",
  "item.minecraft.mojang_banner_pattern.desc": "Lambang",
  "item.minecraft.mojang_banner_pattern.new": "Patron pandji „lambang”",
  "item.minecraft.mooshroom_spawn_egg": "Teloer pewoedjoedan mooshroom",
  "item.minecraft.mourner_pottery_shard": "Serpihan pasoe „doeka”",
  "item.minecraft.mourner_pottery_sherd": "Serpihan pasoe „doeka”",
  "item.minecraft.mule_spawn_egg": "Teloer pewoedjoedan bagal",
  "item.minecraft.mushroom_stew": "Soep djamoer",
  "item.minecraft.music_disc_11": "Pelat muziek",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Pelat muziek",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Pelat muziek",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Pelat muziek",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Pelat muziek",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Pelat muziek",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Pelat muziek",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Pelat muziek",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (kotak muziek)",
  "item.minecraft.music_disc_far": "Pelat muziek",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Pelat muziek",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Pelat muziek",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Pelat muziek",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Pelat muziek",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Pelat muziek",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Pelat muziek",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Pelat muziek",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Pelat muziek",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Pelat muziek",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Pelat muziek",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Pelat muziek",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Pelat muziek",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Daging domba mentah",
  "item.minecraft.name_tag": "Etikét nama",
  "item.minecraft.nautilus_shell": "Tjangkang genggeng",
  "item.minecraft.nautilus_spawn_egg": "Teloer pewoedjoedan genggeng",
  "item.minecraft.nether_brick": "Bata nether",
  "item.minecraft.nether_star": "Bintang Nether",
  "item.minecraft.nether_wart": "Ketoeat Nether",
  "item.minecraft.netherite_axe": "Kapak netherit",
  "item.minecraft.netherite_boots": "Lars netherit",
  "item.minecraft.netherite_chestplate": "Badjoe netherit",
  "item.minecraft.netherite_helmet": "Helm netherit",
  "item.minecraft.netherite_hoe": "Tjangkoel netherit",
  "item.minecraft.netherite_horse_armor": "Zirah koeda netherit",
  "item.minecraft.netherite_ingot": "Netherit batangan",
  "item.minecraft.netherite_leggings": "Tjelana netherit",
  "item.minecraft.netherite_nautilus_armor": "Zirah genggeng netherit",
  "item.minecraft.netherite_pickaxe": "Belioeng netherit",
  "item.minecraft.netherite_scrap": "Kepingan netherit",
  "item.minecraft.netherite_shovel": "Sekop netherit",
  "item.minecraft.netherite_spear": "Tombak netherit",
  "item.minecraft.netherite_sword": "Pedang netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Sablon tempa",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Peningkatan netherit",
  "item.minecraft.oak_boat": "Perahoe eik",
  "item.minecraft.oak_chest_boat": "Perahoe eik dengan peti",
  "item.minecraft.ocelot_spawn_egg": "Teloer pewoedjoedan oselot",
  "item.minecraft.ominous_bottle": "Botol seram",
  "item.minecraft.ominous_trial_key": "Koentji tjobaän seram",
  "item.minecraft.orange_bundle": "Kantong oranje",
  "item.minecraft.orange_dye": "Pewarna oranje",
  "item.minecraft.orange_harness": "Roengkoep oranje",
  "item.minecraft.painting": "Loekisan",
  "item.minecraft.pale_oak_boat": "Perahoe eik poetjat",
  "item.minecraft.pale_oak_chest_boat": "Perahoe eik poetjat dengan peti",
  "item.minecraft.panda_spawn_egg": "Teloer pewoedjoedan panda",
  "item.minecraft.paper": "Kertas",
  "item.minecraft.parched_spawn_egg": "Teloer pewoedjoedan kerontang",
  "item.minecraft.parrot_spawn_egg": "Teloer pewoedjoedan bajan",
  "item.minecraft.phantom_membrane": "Selapoet angan-angan",
  "item.minecraft.phantom_spawn_egg": "Teloer pewoedjoedan angan-angan",
  "item.minecraft.pig_spawn_egg": "Teloer pewoedjoedan babi",
  "item.minecraft.piglin_banner_pattern": "Patron pandji",
  "item.minecraft.piglin_banner_pattern.desc": "Montjong",
  "item.minecraft.piglin_banner_pattern.new": "Patron pandji „montjong”",
  "item.minecraft.piglin_brute_spawn_egg": "Teloer pewoedjoedan piglin ganas",
  "item.minecraft.piglin_spawn_egg": "Teloer pewoedjoedan piglin",
  "item.minecraft.pillager_spawn_egg": "Teloer pewoedjoedan pendjarah",
  "item.minecraft.pink_bundle": "Kantong djambon",
  "item.minecraft.pink_dye": "Pewarna djambon",
  "item.minecraft.pink_harness": "Roengkoep djambon",
  "item.minecraft.pitcher_plant": "Perioek kera",
  "item.minecraft.pitcher_pod": "Polong perioek kera",
  "item.minecraft.plenty_pottery_shard": "Serpihan pasoe „kelimpahan”",
  "item.minecraft.plenty_pottery_sherd": "Serpihan pasoe „kelimpahan”",
  "item.minecraft.poisonous_potato": "Kentang beratjoen",
  "item.minecraft.polar_bear_spawn_egg": "Teloer pewoedjoedan beroeang ijs",
  "item.minecraft.popped_chorus_fruit": "Bertih boeah koor",
  "item.minecraft.porkchop": "Daging babi mentah",
  "item.minecraft.potato": "Kentang",
  "item.minecraft.potion": "Ramoean",
  "item.minecraft.potion.effect.awkward": "Ramoean aneh",
  "item.minecraft.potion.effect.empty": "Ramoean ta' bisa diboeat",
  "item.minecraft.potion.effect.fire_resistance": "Ramoean kebal api",
  "item.minecraft.potion.effect.harming": "Ramoean kesakitan",
  "item.minecraft.potion.effect.healing": "Ramoean penjemboehan",
  "item.minecraft.potion.effect.infested": "Ramoean infestasi",
  "item.minecraft.potion.effect.invisibility": "Ramoean halimoenan",
  "item.minecraft.potion.effect.leaping": "Ramoean lompatan",
  "item.minecraft.potion.effect.levitation": "Ramoean pengapoengan",
  "item.minecraft.potion.effect.luck": "Ramoean keberoentoengan",
  "item.minecraft.potion.effect.mundane": "Ramoean biasa",
  "item.minecraft.potion.effect.night_vision": "Ramoean penglihatan gelap",
  "item.minecraft.potion.effect.oozing": "Ramoean pentjoetjoeran",
  "item.minecraft.potion.effect.poison": "Ramoean ratjoen",
  "item.minecraft.potion.effect.regeneration": "Ramoean regenerasi",
  "item.minecraft.potion.effect.slow_falling": "Ramoean djatoeh lambat",
  "item.minecraft.potion.effect.slowness": "Ramoean kelambatan",
  "item.minecraft.potion.effect.strength": "Ramoean kekoeatan",
  "item.minecraft.potion.effect.swiftness": "Ramoean ketjepatan",
  "item.minecraft.potion.effect.thick": "Ramoean kental",
  "item.minecraft.potion.effect.turtle_master": "Ramoean goeroe penjoe",
  "item.minecraft.potion.effect.water": "Botol aïr",
  "item.minecraft.potion.effect.water_breathing": "Ramoean pernapasan aïr",
  "item.minecraft.potion.effect.weakness": "Ramoean kelemahan",
  "item.minecraft.potion.effect.weaving": "Ramoean meradjoet",
  "item.minecraft.potion.effect.wind_charged": "Ramoean emboesan",
  "item.minecraft.pottery_shard_archer": "Serpihan pasoe „pemanah”",
  "item.minecraft.pottery_shard_arms_up": "Serpihan pasoe „angkat tangan”",
  "item.minecraft.pottery_shard_prize": "Serpihan pasoe „hadiah”",
  "item.minecraft.pottery_shard_skull": "Serpihan pasoe „tengkorak”",
  "item.minecraft.powder_snow_bucket": "Ember saldjoe poeder",
  "item.minecraft.prismarine_crystals": "Kristal prismarien",
  "item.minecraft.prismarine_shard": "Serpihan prismarien",
  "item.minecraft.prize_pottery_shard": "Serpihan pasoe „hadiah”",
  "item.minecraft.prize_pottery_sherd": "Serpihan pasoe „hadiah”",
  "item.minecraft.pufferfish": "Ikan boental",
  "item.minecraft.pufferfish_bucket": "Ember ikan boental",
  "item.minecraft.pufferfish_spawn_egg": "Teloer pewoedjoedan ikan boental",
  "item.minecraft.pumpkin_pie": "Tar laboe",
  "item.minecraft.pumpkin_seeds": "Benih laboe",
  "item.minecraft.purple_bundle": "Kantong oengoe",
  "item.minecraft.purple_dye": "Pewarna oengoe",
  "item.minecraft.purple_harness": "Roengkoep oengoe",
  "item.minecraft.quartz": "Kwars nether",
  "item.minecraft.rabbit": "Daging kelintji mentah",
  "item.minecraft.rabbit_foot": "Kaki kelintji",
  "item.minecraft.rabbit_hide": "Koelit kelintji",
  "item.minecraft.rabbit_spawn_egg": "Teloer pewoedjoedan kelintji",
  "item.minecraft.rabbit_stew": "Soep kelintji",
  "item.minecraft.raiser_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Hiasan zirah „pemelihara”",
  "item.minecraft.ravager_spawn_egg": "Teloer pewoedjoedan pembinasa",
  "item.minecraft.raw_copper": "Tembaga mentah",
  "item.minecraft.raw_gold": "Emas mentah",
  "item.minecraft.raw_iron": "Besi mentah",
  "item.minecraft.recovery_compass": "Kompas pemoelihan",
  "item.minecraft.red_bundle": "Kantong merah",
  "item.minecraft.red_dye": "Pewarna merah",
  "item.minecraft.red_harness": "Roengkoep merah",
  "item.minecraft.redstone": "Serboek redstone",
  "item.minecraft.resin_brick": "Bata damar",
  "item.minecraft.resin_clump": "Goempalan damar",
  "item.minecraft.rib_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Hiasan zirah „roesoek”",
  "item.minecraft.rotten_flesh": "Daging boesoek",
  "item.minecraft.saddle": "Pelana",
  "item.minecraft.salmon": "Salem mentah",
  "item.minecraft.salmon_bucket": "Ember salem",
  "item.minecraft.salmon_spawn_egg": "Teloer pewoedjoedan salem",
  "item.minecraft.scrape_pottery_sherd": "Serpihan pasoe „kikis”",
  "item.minecraft.scute": "Tameng",
  "item.minecraft.sentry_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Hiasan zirah „pengawal”",
  "item.minecraft.shaper_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Hiasan zirah „pembentoek”",
  "item.minecraft.sheaf_pottery_shard": "Serpihan pasoe „berkas”",
  "item.minecraft.sheaf_pottery_sherd": "Serpihan pasoe „berkas”",
  "item.minecraft.shears": "Goenting",
  "item.minecraft.sheep_spawn_egg": "Teloer pewoedjoedan domba",
  "item.minecraft.shelter_pottery_shard": "Serpihan pasoe „naoengan”",
  "item.minecraft.shelter_pottery_sherd": "Serpihan pasoe „naoengan”",
  "item.minecraft.shield": "Perisai",
  "item.minecraft.shield.black": "Perisai hitam",
  "item.minecraft.shield.blue": "Perisai biroe",
  "item.minecraft.shield.brown": "Perisai sawo matang",
  "item.minecraft.shield.cyan": "Perisai nilangsoeka",
  "item.minecraft.shield.gray": "Perisai kelaboe",
  "item.minecraft.shield.green": "Perisai hidjau",
  "item.minecraft.shield.light_blue": "Perisai biroe moeda",
  "item.minecraft.shield.light_gray": "Perisai kelaboe moeda",
  "item.minecraft.shield.lime": "Perisai hidjau poepoes",
  "item.minecraft.shield.magenta": "Perisai patma",
  "item.minecraft.shield.orange": "Perisai oranje",
  "item.minecraft.shield.pink": "Perisai djambon",
  "item.minecraft.shield.purple": "Perisai oengoe",
  "item.minecraft.shield.red": "Perisai merah",
  "item.minecraft.shield.white": "Perisai poetih",
  "item.minecraft.shield.yellow": "Perisai koening",
  "item.minecraft.shulker_shell": "Tjangkang shulker",
  "item.minecraft.shulker_spawn_egg": "Teloer pewoedjoedan shulker",
  "item.minecraft.sign": "Papan tanda",
  "item.minecraft.silence_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Hiasan zirah „keheningan”",
  "item.minecraft.silverfish_spawn_egg": "Teloer pewoedjoedan gegat",
  "item.minecraft.skeleton_horse_spawn_egg": "Teloer pewoedjoedan koeda bengkarak",
  "item.minecraft.skeleton_spawn_egg": "Teloer pewoedjoedan bengkarak",
  "item.minecraft.skull_banner_pattern": "Patron pandji",
  "item.minecraft.skull_banner_pattern.desc": "Roepa tengkorak",
  "item.minecraft.skull_banner_pattern.new": "Patron pandji „roepa tengkorak”",
  "item.minecraft.skull_pottery_shard": "Serpihan pasoe „tengkorak”",
  "item.minecraft.skull_pottery_sherd": "Serpihan pasoe „tengkorak”",
  "item.minecraft.slime_ball": "Bola geladir",
  "item.minecraft.slime_spawn_egg": "Teloer pewoedjoedan geladir",
  "item.minecraft.smithing_template": "Sablon tempa",
  "item.minecraft.smithing_template.applies_to": "Diterapkan pada:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Tambah batangan atau kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Zirah",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Tambah sepotong zirah",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Batangan dan kristal",
  "item.minecraft.smithing_template.ingredients": "Bahan:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Tambah netherit batangan",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Peralatan berlian",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Tambah zirah, sendjata atau alat berlian",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherit batangan",
  "item.minecraft.smithing_template.upgrade": "Tingkatan: ",
  "item.minecraft.sniffer_spawn_egg": "Teloer pewoedjoedan pengendoes",
  "item.minecraft.snort_pottery_shard": "Serpihan pasoe „dengoes”",
  "item.minecraft.snort_pottery_sherd": "Serpihan pasoe „dengoes”",
  "item.minecraft.snout_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Hiasan zirah „montjong”",
  "item.minecraft.snow_golem_spawn_egg": "Teloer pewoedjoedan golem saldjoe",
  "item.minecraft.snowball": "Bola saldjoe",
  "item.minecraft.spectral_arrow": "Panah bersinar",
  "item.minecraft.spider_eye": "Mata laba-laba",
  "item.minecraft.spider_spawn_egg": "Teloer pewoedjoedan laba-laba",
  "item.minecraft.spire_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Hiasan zirah „menara”",
  "item.minecraft.splash_potion": "Ramoean tjiprat",
  "item.minecraft.splash_potion.effect.awkward": "Ramoean tjiprat aneh",
  "item.minecraft.splash_potion.effect.empty": "Ramoean tjiprat ta' bisa diboeat",
  "item.minecraft.splash_potion.effect.fire_resistance": "Ramoean tjiprat kebal api",
  "item.minecraft.splash_potion.effect.harming": "Ramoean tjiprat kesakitan",
  "item.minecraft.splash_potion.effect.healing": "Ramoean tjiprat penjemboehan",
  "item.minecraft.splash_potion.effect.infested": "Ramoean tjiprat infestasi",
  "item.minecraft.splash_potion.effect.invisibility": "Ramoean tjiprat halimoenan",
  "item.minecraft.splash_potion.effect.leaping": "Ramoean tjiprat lompatan",
  "item.minecraft.splash_potion.effect.levitation": "Ramoean tjiprat pengapoengan",
  "item.minecraft.splash_potion.effect.luck": "Ramoean tjiprat keberoentoengan",
  "item.minecraft.splash_potion.effect.mundane": "Ramoean tjiprat biasa",
  "item.minecraft.splash_potion.effect.night_vision": "Ramoean tjiprat penglihatan gelap",
  "item.minecraft.splash_potion.effect.oozing": "Ramoean tjiprat pentjoetjoeran",
  "item.minecraft.splash_potion.effect.poison": "Ramoean tjiprat ratjoen",
  "item.minecraft.splash_potion.effect.regeneration": "Ramoean tjiprat regenerasi",
  "item.minecraft.splash_potion.effect.slow_falling": "Ramoean tjiprat djatoeh lambat",
  "item.minecraft.splash_potion.effect.slowness": "Ramoean tjiprat kelambatan",
  "item.minecraft.splash_potion.effect.strength": "Ramoean tjiprat kekoeatan",
  "item.minecraft.splash_potion.effect.swiftness": "Ramoean tjiprat ketjepatan",
  "item.minecraft.splash_potion.effect.thick": "Ramoean tjiprat kental",
  "item.minecraft.splash_potion.effect.turtle_master": "Ramoean tjiprat goeroe penjoe",
  "item.minecraft.splash_potion.effect.water": "Botol aïr tjiprat",
  "item.minecraft.splash_potion.effect.water_breathing": "Ramoean tjiprat pernapasan aïr",
  "item.minecraft.splash_potion.effect.weakness": "Ramoean tjiprat kelemahan",
  "item.minecraft.splash_potion.effect.weaving": "Ramoean tjiprat meradjoet",
  "item.minecraft.splash_potion.effect.wind_charged": "Ramoean tjiprat emboesan",
  "item.minecraft.spruce_boat": "Perahoe tjemara",
  "item.minecraft.spruce_chest_boat": "Perahoe tjemara dengan peti",
  "item.minecraft.spyglass": "Kéker",
  "item.minecraft.squid_spawn_egg": "Teloer pewoedjoedan tjoemi-tjoemi",
  "item.minecraft.stick": "Tongkat",
  "item.minecraft.stone_axe": "Kapak batoe",
  "item.minecraft.stone_hoe": "Tjangkoel batoe",
  "item.minecraft.stone_pickaxe": "Belioeng batoe",
  "item.minecraft.stone_shovel": "Sekop batoe",
  "item.minecraft.stone_spear": "Tombak batoe",
  "item.minecraft.stone_sword": "Pedang batoe",
  "item.minecraft.stray_spawn_egg": "Teloer pewoedjoedan toealang",
  "item.minecraft.strider_spawn_egg": "Teloer pewoedjoedan pengaroeng",
  "item.minecraft.string": "Benang",
  "item.minecraft.sugar": "Goela",
  "item.minecraft.suspicious_stew": "Soep mentjoerigakan",
  "item.minecraft.sweet_berries": "Boeni manis",
  "item.minecraft.tadpole_bucket": "Ember beroedoe",
  "item.minecraft.tadpole_spawn_egg": "Teloer pewoedjoedan beroedoe",
  "item.minecraft.tide_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Hiasan zirah „gelombang pasang”",
  "item.minecraft.tipped_arrow": "Panah tjeloepan",
  "item.minecraft.tipped_arrow.effect.awkward": "Panah tjeloepan",
  "item.minecraft.tipped_arrow.effect.empty": "Panah tjeloepan ta' bisa diboeat",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Panah kebal api",
  "item.minecraft.tipped_arrow.effect.harming": "Panah kesakitan",
  "item.minecraft.tipped_arrow.effect.healing": "Panah penjemboehan",
  "item.minecraft.tipped_arrow.effect.infested": "Panah infestasi",
  "item.minecraft.tipped_arrow.effect.invisibility": "Panah halimoenan",
  "item.minecraft.tipped_arrow.effect.leaping": "Panah lompatan",
  "item.minecraft.tipped_arrow.effect.levitation": "Panah pengapoengan",
  "item.minecraft.tipped_arrow.effect.luck": "Panah keberoentoengan",
  "item.minecraft.tipped_arrow.effect.mundane": "Panah tjeloepan",
  "item.minecraft.tipped_arrow.effect.night_vision": "Panah penglihatan gelap",
  "item.minecraft.tipped_arrow.effect.oozing": "Panah pentjoetjoeran",
  "item.minecraft.tipped_arrow.effect.poison": "Panah ratjoen",
  "item.minecraft.tipped_arrow.effect.regeneration": "Panah regenerasi",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Panah djatoeh lambat",
  "item.minecraft.tipped_arrow.effect.slowness": "Panah kelambatan",
  "item.minecraft.tipped_arrow.effect.strength": "Panah kekoeatan",
  "item.minecraft.tipped_arrow.effect.swiftness": "Panah ketjepatan",
  "item.minecraft.tipped_arrow.effect.thick": "Panah tjeloepan",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Panah goeroe penjoe",
  "item.minecraft.tipped_arrow.effect.water": "Panah tjiprat",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Panah pernapasan aïr",
  "item.minecraft.tipped_arrow.effect.weakness": "Panah kelemahan",
  "item.minecraft.tipped_arrow.effect.weaving": "Panah meradjoet",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Panah emboesan",
  "item.minecraft.tnt_minecart": "Kereta tambang dengan TNT",
  "item.minecraft.torchflower_seeds": "Benih boenga obor",
  "item.minecraft.totem_of_undying": "Azimat keabadian",
  "item.minecraft.trader_llama_spawn_egg": "Teloer pewoedjoedan lama handelar",
  "item.minecraft.trial_key": "Koentji tjobaän",
  "item.minecraft.trident": "Serampang",
  "item.minecraft.tropical_fish": "Ikan tropis",
  "item.minecraft.tropical_fish_bucket": "Ember ikan tropis",
  "item.minecraft.tropical_fish_spawn_egg": "Teloer pewoedjoedan ikan tropis",
  "item.minecraft.turtle_helmet": "Tjangkang penjoe",
  "item.minecraft.turtle_scute": "Tameng penjoe",
  "item.minecraft.turtle_spawn_egg": "Teloer pewoedjoedan penjoe",
  "item.minecraft.vex_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Hiasan zirah „oesik”",
  "item.minecraft.vex_spawn_egg": "Teloer pewoedjoedan toejoel",
  "item.minecraft.villager_spawn_egg": "Teloer pewoedjoedan pendoedoek",
  "item.minecraft.vindicator_spawn_egg": "Teloer pewoedjoedan pembela",
  "item.minecraft.wandering_trader_spawn_egg": "Teloer pewoedjoedan handelar keliling",
  "item.minecraft.ward_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Hiasan zirah „djaga”",
  "item.minecraft.warden_spawn_egg": "Teloer pewoedjoedan penoenggoe",
  "item.minecraft.warped_fungus_on_a_stick": "Djamoer keroekoet ditongkat",
  "item.minecraft.water_bucket": "Ember aïr",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Hiasan zirah „pandoe”",
  "item.minecraft.wheat": "Gandoem",
  "item.minecraft.wheat_seeds": "Benih gandoem",
  "item.minecraft.white_bundle": "Kantong poetih",
  "item.minecraft.white_dye": "Pewarna poetih",
  "item.minecraft.white_harness": "Roengkoep poetih",
  "item.minecraft.wild_armor_trim_smithing_template": "Sablon tempa",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Hiasan zirah „liar”",
  "item.minecraft.wind_charge": "Bola angin",
  "item.minecraft.witch_spawn_egg": "Teloer pewoedjoedan penjihir",
  "item.minecraft.wither_skeleton_spawn_egg": "Teloer pewoedjoedan bengkarak Wither",
  "item.minecraft.wither_spawn_egg": "Teloer pewoedjoedan Wither",
  "item.minecraft.wolf_armor": "Zirah serigala",
  "item.minecraft.wolf_spawn_egg": "Teloer pewoedjoedan serigala",
  "item.minecraft.wooden_axe": "Kapak kajoe",
  "item.minecraft.wooden_hoe": "Tjangkoel kajoe",
  "item.minecraft.wooden_pickaxe": "Belioeng kajoe",
  "item.minecraft.wooden_shovel": "Sekop kajoe",
  "item.minecraft.wooden_spear": "Tombak kajoe",
  "item.minecraft.wooden_sword": "Pedang kajoe",
  "item.minecraft.writable_book": "Boekoe dan pena",
  "item.minecraft.written_book": "Boekoe tertoelis",
  "item.minecraft.yellow_bundle": "Kantong koening",
  "item.minecraft.yellow_dye": "Pewarna koening",
  "item.minecraft.yellow_harness": "Roengkoep koening",
  "item.minecraft.zoglin_spawn_egg": "Teloer pewoedjoedan zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Teloer pewoedjoedan koeda zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Teloer pewoedjoedan genggeng zombi",
  "item.minecraft.zombie_spawn_egg": "Teloer pewoedjoedan zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Teloer pewoedjoedan pendoedoek zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Teloer pewoedjoedan piglin zombi"
}
export const qid = items; 
